import { useEffect, useState, useRef, useMemo } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from 'react-toastify';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import JsBarcode from 'jsbarcode';
import Swal from "sweetalert2";
import Select from 'react-select';
import { useNavigate } from "react-router-dom";
import NewBroker from '../models/NewBroker';

function OpdRegistrations() {
    const [ldata, setLdata] = useState(null);
    const [headerLogo, setHeaderLogo] = useState('');
     const [isSaved, setIsSaved] = useState(false);
      const [uhidSuggestions, setUhidSuggestions] = useState([]);
      const [isReloading, setIsReloading] = useState(false);

      const [ipdSearchInput, setIpdSearchInput] = useState('');
      const ipdSearchDebounceRef = useRef(null);
      const [showBrokerModal, setShowBrokerModal] = useState(false);
    const [formData, setFormData] = useState({
        cats:[],
        docs:[],
        wards:[],
        beds:[],
        pkgs:[],
        cases:[],
        ipd_id: '',
        ipd_uhid:"",
        ipd_patient_title: 'Mr.',
        ipd_patient_name: '',
        ipd_patient_gender: 'Male',
        ipd_patient_mobile: '',
        ipd_guardien_title: '',
        ipd_guardien_name: '',
        ipd_address: '',
        ipd_city: '',
        ipd_age: '',
        ipd_age_year: '',          // new: years (number string)
ipd_age_month: '',         // new: months (number string)
ipd_age_day: '',  
        ipd_type: '',
        ipd_specality: '',
        ipd_refer_doctor: '',
        ipd_file_number: '',
        ipd_attachment: '',
        ipd_reg_date: '',
        ipd_policy_name: '',
        ipd_policy_no: '',
        ipd_policy_address: '',
        ipd_case: '',
        ipd_mlc_number: '',
        ipd_cont_number: '',
        ipd_ward: '',
        ipd_bed: '',
        ipd_bed_price: '',
        ipd_price: '',
        ipd_pkg: '',
        ipd_pkg_price: '',
        ipd_pkg_original_price: '',
        ipd_pkg_discount: '',
        ipd_total_price: '',
        ipd_discount: '',
        ipd_reg_charges: '',
        ipd_advance: '0',
        ipd_paid: '0',
        ipd_due: '',
        ipd_pay_mode: 'cash',
        ipd_remarks: '',
        ipd_user: '',
        page_no: 0,
        alertMsg: '',
        alertMsgTyp: '',
        search_key: '',
        isAlert: false,
        ipd_reg_charges_original: '',
    });
// insurance & tpa select options
const [insuranceOptions, setInsuranceOptions] = useState([]);
const [tpaOptions, setTpaOptions] = useState([]);
// ── NEW states for phone search ──
const [ipdSearchMode, setIpdSearchMode]         = useState('phone');
const [ipdPhoneSearch, setIpdPhoneSearch]       = useState('');
const [ipdPatientResults, setIpdPatientResults] = useState([]);
const [showIpdPatientModal, setShowIpdPatientModal] = useState(false);
const [ipdSearchLoading, setIpdSearchLoading]   = useState(false);
// selected values (store full option object or null)
const [selectedInsurance, setSelectedInsurance] = useState(null);
const [selectedTpa, setSelectedTpa] = useState(null);
const [originalRecord, setOriginalRecord] = useState(null);
    // UI helper states
const [filteredDoctors, setFilteredDoctors] = useState([]);
const [showSpecOptions, setShowSpecOptions] = useState(false);
const [showDocOptions, setShowDocOptions] = useState(false);
const [specSearch, setSpecSearch] = useState("");
const [docSearch, setDocSearch] = useState("");
const navigate = useNavigate();

// Broker select state (add after other useState declarations)
// const [brokerOptions, setBrokerOptions] = useState([]);
// const [brokerId, setBrokerId] = useState('');       
// const [brokerLabel, setBrokerLabel] = useState(''); 
// const [loadingBrokers, setLoadingBrokers] = useState(false);


const [brokerOptions, setBrokerOptions] = useState([]);
const [selectedBrokers, setSelectedBrokers] = useState([]); // multi-select array
const [loadingBrokers, setLoadingBrokers] = useState(false);
 
// backward compat (derived)
const brokerId = selectedBrokers.map(b => b.value).join(',');
const brokerLabel = selectedBrokers.map(b => b.label).join(', ');


// debounce ref for type-ahead
const brokerDebounceRef = useRef(null);
//const specialityOptions = (formData.cats || []).map(c => ({ value: c.cat_id, label: c.cat_name, raw: c }));
const packageOptions = (formData.pkgs || []).map(p => ({ value: p.cat_id, label: p.cat_name, raw: p }));
const wardOptions = (formData.wards || []).map(w => ({ value: w.cat_id, label: w.cat_name, raw: w }));
// Update bedOptions to show availability status
const bedOptions = (formData.beds || []).map(b => {
  const isOccupied = String(b.status) === "1" || b.status === 1;
  const isCurrentBed = String(b.bed_id) === String(formData.ipd_bed);

 
// ✅ Helper to attach logged-in user info to any FormData


  
  let label = b.bed_name || '';
  
  // Add indicator for occupied beds (only shown for currently assigned bed during edit)
  if (isOccupied && isCurrentBed) {
    label = `${b.bed_name} (Current - Assigned to this patient)`;
  } else if (isOccupied) {
    label = `${b.bed_name} (Occupied)`;
  }
  
  return { 
    value: b.bed_id, 
    label: label, 
    raw: b,
    isDisabled: isOccupied && !isCurrentBed // Disable occupied beds except current
  };
});
const caseOptions = (formData.cases || []).map(c => ({ value: c.cat_id, label: c.cat_name, raw: c }));
//const doctorOptions = (formData.docs || []).map(d => ({ value: d.user_id, label: d.fname, raw: d }));






const [specialityOptions, setSpecialityOptions] = useState([]);
const [doctorOptions, setDoctorOptions] = useState([]);

// NOTE: we keep specSearch and docSearch as visible labels (you already have them)
  
// Build/select option helpers
const toSpecOption = (cat) => ({ value: String(cat.cat_id), label: cat.cat_name, raw: cat });
const toDocOption = (doc) => {
  // try to build a nice label with name + maybe designation/department if available
  const name = doc.fname || doc.name || doc.fullname || doc.user_name || '';
  const extra = doc.designation || doc.doc?.designation || doc.speciality || '';
  const lbl = extra ? `${name} — ${extra}` : name;
  return { value: String(doc.user_id ?? doc.id ?? ''), label: lbl, raw: doc };
};
const loadBrokers = async (search = '') => {
  try {
    setLoadingBrokers(true);
    const fd = new FormData();
    fd.append('search_key', search || '');
    fd.append('page_no', 'none');
    const res = await axios.post(AppConst.BASE_URL + AppConst.getBrokerListUrl, fd, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    const records = (res?.data?.records && Array.isArray(res.data.records)) ? res.data.records : [];
 
    const opts = records.map(r => {
      const name = `${(r.fname || '').trim()}${r.lname ? ' ' + (r.lname || '').trim() : ''}`.trim();
      const phone = (r.mobile || '').trim();
      // Label: "Name (Phone)" or just "Phone" if no name
      let label = name || 'Unknown';
      if (phone) label = `${label} (${phone})`;
      
      return {
        value: String(r.broker_id ?? r.id ?? r.user_id ?? ''),
        label: label,
        phone: phone,  // keep separate for search
        name: name,    // keep separate for display
        raw: r
      };
    });
 
    setBrokerOptions(prev => {
      const newOpts = [...opts];
      // Keep currently selected brokers in options list
      for (const sel of selectedBrokers) {
        if (!newOpts.find(o => String(o.value) === String(sel.value))) {
          newOpts.unshift(sel);
        }
      }
      return newOpts;
    });
  } catch (err) {
    console.error('loadBrokers', err);
    setBrokerOptions([]);
  } finally {
    setLoadingBrokers(false);
  }
};

useEffect(() => {
  const timer = setTimeout(() => loadBrokers(''), 200);
  return () => clearTimeout(timer);
}, []);



// ---------- Build specialityOptions from formData.cats whenever cats change ----------
useEffect(() => {
  try {
    const cats = Array.isArray(formData.cats) ? formData.cats : [];
    const opts = cats.map(toSpecOption);
    setSpecialityOptions(opts);
  } catch (err) {
    console.warn('Failed to build specialityOptions', err);
    setSpecialityOptions([]);
  }
}, [formData.cats]);

// ---------- Build full doctorOptions (unfiltered) whenever docs list changes ----------
useEffect(() => {
  try {
    const docs = Array.isArray(formData.docs) ? formData.docs : [];
    const opts = docs.map(toDocOption);
    setDoctorOptions(opts);
  } catch (err) {
    console.warn('Failed to build doctorOptions', err);
    setDoctorOptions([]);
  }
}, [formData.docs]);

// ---------- Filter doctorOptions when a speciality is selected ----------
useEffect(() => {
  try {
    const specVal = String(formData.ipd_specality || '').trim().toLowerCase();
    const docs = Array.isArray(formData.docs) ? formData.docs : [];

    if (!specVal) {
      // no speciality chosen => show all doctors
      setDoctorOptions(docs.map(toDocOption));
      return;
    }

    const filtered = docs.filter(doc => {
      // candidate fields that can contain speciality text
      const cand = [];
      if (doc?.doc?.doc_specality) cand.push(String(doc.doc.doc_specality));
      if (doc?.doc_specality) cand.push(String(doc.doc_specality));
      if (doc?.speciality) cand.push(String(doc.speciality));
      if (doc?.specility) cand.push(String(doc.specility));
      if (doc?.specialization) cand.push(String(doc.specialization));
      // also check name fields — useful if speciality value is the doctor's name sometimes
      if (doc?.fname) cand.push(String(doc.fname));
      if (doc?.surname) cand.push(String(doc.surname));
      if (doc?.user_id !== undefined && doc?.user_id !== null) cand.push(String(doc.user_id));

      return cand.some(c => {
        if (!c) return false;
        const lower = c.toLowerCase();
        return lower === specVal || lower.includes(specVal);
      });
    });

    setDoctorOptions(filtered.map(toDocOption));
  } catch (err) {
    console.warn('Doctor filter error', err);
    setDoctorOptions(Array.isArray(formData.docs) ? formData.docs.map(toDocOption) : []);
  }
}, [formData.ipd_specality, formData.docs]);

// ---------- Handlers ----------




// If you want the earlier behavior "when speciality changes call initData1()" (to fetch docs from server)
// you can uncomment or add this watcher:
useEffect(() => {
  // if you used to call initData1 when speciality changed, re-enable:
  // initData1(); // (it already uses formData.ipd_specality inside)
  // no-op by default
}, [formData.ipd_specality]);




const admissionData = useMemo(() => ({
  uhid: formData.ipd_uhid || '',
  patientName: formData.ipd_patient_name || '',
  ageGender: `${formData.ipd_age || ''} / ${formData.ipd_patient_gender || ''}`,
  address: formData.ipd_address || '',
  phone: formData.ipd_patient_mobile || '',
  ward: formData.ipd_ward_name || '',
  bed: formData.ipd_bed_name || '',
  guardian: formData.ipd_guardien_name || '',
  admissionDate: formData.ipd_datetime || '',
  referredDoctor: formData.ipd_refer_doctor || '',
  department: formData.ipd_specality || '',
}), [
  formData.ipd_uhid,
  formData.ipd_patient_name,
  formData.ipd_age,
  formData.ipd_patient_gender,
  formData.ipd_address,
  formData.ipd_patient_mobile,
  formData.ipd_ward_name,
  formData.ipd_bed_name,
  formData.ipd_guardien_name,
  formData.ipd_datetime,
  formData.ipd_refer_doctor,
  formData.ipd_specality
]);


const onSelectSpeciality = (opt) => {
  const id = opt ? String(opt.value) : '';
  handleSpecSelect(id); // reuse your existing function
};

const onSelectDoctor = (opt) => {
  const id = opt ? String(opt.value) : '';
  handleDocSelect(id); // reuse your existing function
};

const onSelectPackage = (opt) => {
  if (!opt) {
    setFormData(prev => ({
      ...prev,
      ipd_pkg: '',
      ipd_pkg_price: '',
      ipd_pkg_original_price: ''
    }));
    return;
  }

  const p = opt.raw || {};
  const price = Number(p.cat_type1 || p.price || 0);

  setFormData(prev => ({
    ...prev,
    ipd_pkg: String(opt.value),
    ipd_pkg_price: price,              // editable value
    ipd_pkg_original_price: price,     // preserve original
    ipd_pkg_discount: ''
  }));
};

const onSelectWard = async (opt) => {
  const isEditing = !!formData.ipd_id;
  const newWardId = opt ? String(opt.value) : '';

  if (isEditing && formData.ipd_bed && newWardId !== String(formData.ipd_ward || '')) {
    Swal.fire({
      title: "Bed Already Allotted",
      html: `This patient already has a bed in the current ward.<br>
             Please use <b>Bed Transfer</b> from Bed Details to change ward/bed.`,
      icon: "warning",
      confirmButtonText: "OK",
    });
    return;
  }

  const id = opt ? String(opt.value) : '';
  handleWardSelect(id);
};

const onSelectBed = (opt) => {
  const isEditing     = !!formData.ipd_id;
  const currentBedId  = String(formData.ipd_bed || '');
  const newBedId      = opt ? String(opt.value) : '';

  // Block direct bed change for an already-allotted patient
  if (isEditing && currentBedId && newBedId !== currentBedId) {
    const currentBedName =
      formData.ipd_bed_name ||
      bedSearch ||
      findNameById(formData.ipd_bed, formData.beds, "bed_id", "bed_name") ||
      currentBedId;

    Swal.fire({
      title: "Bed Already Allotted",
      html: `This patient is already allotted <b>${escapeHtml(currentBedName)}</b>.<br>
             Please keep this bed and use <b>Bed Transfer</b> from Bed Details to move the patient.`,
      icon: "warning",
      confirmButtonText: "OK",
    });
    return; // do not change the bed
  }

  if (!opt) {
    setFormData(prev => ({ ...prev, ipd_bed: '', ipd_bed_price: '' }));
    return;
  }
  const b = opt.raw || {};
  setFormData(prev => ({ ...prev, ipd_bed: String(opt.value), ipd_bed_price: b.bed_price || 0 }));
};

const onSelectCase = (opt) => {
  const id = opt ? String(opt.value) : '';
  handleCaseSelect(id); // reuse existing
};

const attachUserInfo = (fd) => {
  try {
    const stored = sessionStorage.getItem("ldata");
    if (stored) {
      const u = JSON.parse(stored);
      fd.append('user_id',   u.user_id   || '');
      fd.append('user_name', `${u.fname || ''} ${u.lname || ''}`.trim());
      fd.append('user_role', u.role_id   || u.role_name || '');
    }
  } catch (e) {
    console.warn("attachUserInfo failed:", e);
  }
  return fd;
};

// --- helper: generate readable IPD file number ---
const fetchNextIpdNo = async () => {
  try {
    const res = await axios.get(
      AppConst.BASE_URL + AppConst.getNextIpdNoUrl
    );

    if (res.data.status) {
      setFormData(prev => ({
        ...prev,
        ipd_file_number: res.data.ipd_file_number
      }));
    }
  } catch (err) {
    console.error("Failed to fetch next IPD number", err);
  }
};

useEffect(() => {
  fetchNextIpdNo();
}, []);


// near top of component, create handler functions (or put inside component scope)
const preventWheel = (e) => {
  e.preventDefault();
};
// ---------- small helpers (add once near other helpers) ----------
const parseAmountSafeLocal = (v, fallback = 0) => {
  if (v === "" || v === null || v === undefined) return fallback;
  if (typeof v === "number") return isFinite(v) ? v : fallback;
  const s = String(v).replace(/[^0-9.-]+/g, "");
  const n = parseFloat(s);
  return isNaN(n) ? fallback : n;
};

const computeTotalsFrom = (state) => {
  const regOriginal = parseAmountSafeLocal(state.ipd_reg_charges_original, parseAmountSafeLocal(state.ipd_reg_charges, 0));
  const pkgOriginal = parseAmountSafeLocal(
    state.ipd_pkg_price,
    0
  );
  const pkgDiscount = parseAmountSafeLocal(state.ipd_pkg_discount, 0);
  const discountAmt = parseAmountSafeLocal(state.ipd_discount, 0);
  const paidNow = parseAmountSafeLocal(state.ipd_paid, 0);

  // Registration visible after discount (clamped)
  const regVisible = Math.max(0, regOriginal - Math.min(discountAmt, regOriginal));

  // Subtotal = visible registration + package - package discount
  const subtotal = Math.max(0, regVisible + pkgOriginal - pkgDiscount);
  
  // Due = subtotal - paid (not subtracting advance here as it's stored separately)
  const due = Math.max(0, subtotal - paidNow);

  return {
    ipd_reg_charges: Number(regVisible).toFixed(2),
    ipd_total_price: Number(subtotal).toFixed(2),
    ipd_due: Number(due).toFixed(2),
    _regOriginal: regOriginal,
    _discountAmt: discountAmt
  };
};

// helper to attach non-passive wheel listener on focus
const attachWheelPrevent = (el) => {
  if (!el) return;
  // remove any previous to be safe
  try { el.removeEventListener('wheel', preventWheel, { passive: false }); } catch(_) {}
  el.addEventListener('wheel', preventWheel, { passive: false });
};

// helper to remove it on blur
const detachWheelPrevent = (el) => {
  if (!el) return;
  try { el.removeEventListener('wheel', preventWheel, { passive: false }); } catch(_) {}
};

// Refs to detect clicks outside the dropdowns
const specRef = useRef();
const docRef = useRef();
// near other refs (e.g. specRef, docRef ...)
const formRef = useRef(formData);

// keep ref in sync with latest formData
useEffect(() => {
  formRef.current = formData;
}, [formData]);

const [pkgSearch, setPkgSearch] = useState("");
const [showPkgOptions, setShowPkgOptions] = useState(false);
const pkgRef = useRef();

const [wardSearch, setWardSearch] = useState("");
const [showWardOptions, setShowWardOptions] = useState(false);
const wardRef = useRef();

const [bedSearch, setBedSearch] = useState("");
const [showBedOptions, setShowBedOptions] = useState(false);
const bedRef = useRef();

const [caseSearch, setCaseSearch] = useState("");
const [showCaseOptions, setShowCaseOptions] = useState(false);
const caseRef = useRef();
// create a ref for the canvas we'll use to render the barcode
// place near other helpers inside your component
const barcodeCanvasRef = useRef(null);
// sanitize helpers

const formatDateTime12h = (dateTimeStr) => {
  if (!dateTimeStr) return "";
  try {
    const d = new Date(dateTimeStr);
    if (isNaN(d.getTime())) return dateTimeStr;
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    let hours = d.getHours();
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const seconds = String(d.getSeconds()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${day}-${month}-${year} ${String(hours).padStart(2,"0")}:${minutes}:${seconds} ${ampm}`;
  } catch (e) {
    console.warn("formatDateTime12h failed:", e);
    return dateTimeStr;
  }
};
const sanitizeStr = (v) => {
  if (v === null || v === undefined) return '';
  // sometimes backend sends "null"/"NULL"
  if (typeof v === 'string' && v.trim().toLowerCase() === 'null') return '';
  return String(v);
};

const sanitizeNumber = (v, fallback = 0) => {
  if (v === null || v === undefined) return fallback;
  if (typeof v === 'string' && v.trim().toLowerCase() === 'null') return fallback;
  const n = parseFloat(v);
  return isNaN(n) ? fallback : n;
};


const pad = (v) => (v === '' || v === null || v === undefined) ? '' : String(v);
const formatAgeString = (y, m, d) => {
  const parts = [];
  if (y && Number(y) > 0) parts.push(`${Number(y)} Yr${Number(y) > 1 ? 's' : ''}`);
  if (m && Number(m) > 0) parts.push(`${Number(m)} Mo${Number(m) > 1 ? 's' : ''}`);
  if (d && Number(d) > 0) parts.push(`${Number(d)} Dy${Number(d) > 1 ? 's' : ''}`);
  return parts.length ? parts.join(' / ') : '';
};


const generateBarcodeDataUrl = (value, options = {}) => {
  const canvas = barcodeCanvasRef.current || document.createElement('canvas');
  const v = (value && String(value).trim()) ? String(value).trim() : 'NA';
  try {
    JsBarcode(canvas, v, {
      format: options.format || 'CODE128',
      width: options.width || 2,
      height: options.height || 60,
      displayValue: options.displayValue === undefined ? false : options.displayValue,
      margin: options.margin || 5,
      textMargin: 0
    });
    return canvas.toDataURL('image/png');
  } catch (err) {
    console.error('Barcode generation failed', err);
    return null;
  }
};

const escapeHtml = (unsafe) => {
  if (!unsafe) return '';
  return String(unsafe)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
};

/**
 * Print using a hidden iframe to avoid popup blocker.
 * Trigger must be a user click (e.g. onClick handler) — then the browser will allow printing.
 */

// set a default ipd_file_number for NEW records (don't override existing)
// useEffect(() => {
//   // Only set when ipd_id is empty AND ipd_file_number is empty
//   setFormData(prev => {
//     if (!prev.ipd_id && (!prev.ipd_file_number || String(prev.ipd_file_number).trim() === "")) {
//       return { ...prev, ipd_file_number: generateIpdFileNumber() };
//     }
//     return prev;
//   });
//   // run once on mount
//   // eslint-disable-next-line react-hooks/exhaustive-deps
// }, []);


// when formData has insurance id prefilled, select corresponding option
useEffect(() => {
  if (formData.ipd_insurance_id || formData.ipd_policy_name) {
    const id = String(formData.ipd_insurance_id || '');
    const found = insuranceOptions.find(o => String(o.value) === id);
    if (found) setSelectedInsurance(found);
    else if (formData.ipd_policy_name) {
      // fallback: create a temporary option showing the name
      setSelectedInsurance({ value: '', label: formData.ipd_policy_name, raw: null });
    }
  }
}, [insuranceOptions, formData.ipd_insurance_id, formData.ipd_policy_name]);

// when formData has tpa id prefilled, select it
useEffect(() => {
  if (formData.ipd_tpa_id || formData.ipd_policy_no) {
    const id = String(formData.ipd_tpa_id || '');
    const found = tpaOptions.find(o => String(o.value) === id);
    if (found) setSelectedTpa(found);
    else if (formData.ipd_policy_no) {
      setSelectedTpa({ value: '', label: formData.ipd_policy_no, raw: null });
    }
  }
}, [tpaOptions, formData.ipd_tpa_id, formData.ipd_policy_no]);

// filter doctors when speciality or docs update
useEffect(() => {
    if (formData.ipd_specality) {
        const filtered = formData.docs.filter(
            doc => doc.doc?.doc_specality === formData.ipd_specality
        );
        setFilteredDoctors(filtered);
    } else {
        setFilteredDoctors(formData.docs);
    }
}, [formData.ipd_specality, formData.docs]);

// close dropdowns on outside click (single handler)
useEffect(() => {
    const handleClickOutside = (event) => {
        if (specRef.current && !specRef.current.contains(event.target)) {
            setShowSpecOptions(false);
        }
        if (docRef.current && !docRef.current.contains(event.target)) {
            setShowDocOptions(false);
        }
        if (pkgRef.current && !pkgRef.current.contains(event.target)) setShowPkgOptions(false);
        if (wardRef.current && !wardRef.current.contains(event.target)) setShowWardOptions(false);
        if (bedRef.current && !bedRef.current.contains(event.target)) setShowBedOptions(false);
        if (caseRef.current && !caseRef.current.contains(event.target)) setShowCaseOptions(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);

// select speciality
const handleSpecSelect = (catId) => {
    setFormData(prev => ({
        ...prev,
        ipd_specality: catId,
        ipd_refer_doctor: "",
    }));
    setSpecSearch("");
    setDocSearch("");
    setShowSpecOptions(false);
};
// true only for admin users
const isAdmin = (() => {
  const roleName = String(ldata?.role_name ?? ldata?.role ?? '').toLowerCase();
  const roleId   = String(ldata?.role_id ?? '');
  return roleName.includes('admin') || roleId === '1';
})();
// select doctor
// select doctor (auto-pick the doctor's speciality)
const handleDocSelect = (docId) => {
  const selectedDoc =
      formData.docs.find(doc => String(doc.user_id) === String(docId)) || null;

  // grab the doctor's speciality from the nested doc object
  const docSpec = selectedDoc?.doc?.doc_specality ?? '';

  setFormData((prev) => ({
      ...prev,
      ipd_refer_doctor: docId,
      ipd_specality: docSpec || prev.ipd_specality,  // 👈 auto speciality
  }));

  setDocSearch(selectedDoc ? selectedDoc.fname : "");
  setShowDocOptions(false);
};

// load doctor list (initData1)
const initData1 = async () => {
    const storedData = sessionStorage.getItem("ldata");
    if (storedData) {
        const parsed = JSON.parse(storedData);

         const fd2 = new FormData();
        fd2.append('type', "doctor");
        fd2.append('search_key', "");
        fd2.append('page_no', "none");
        fd2.append('doc_specality', formData.ipd_specality);
        fd2.append('user_cre_by', 1 + "");
        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd2, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            if (response.data.status) {

                var records = response.data.records;
                if (records != null && records != undefined) {
                    setFormData(prev => ({
                        ...prev,
                        docs: records
                    }));
                }
            }
        } catch (error) {

        }
    }
}
useEffect(() => {
    initData1();
}, [formData.ipd_specality]);

// package select helper
const handlePackageSelect = (selectedPackage) => {
    setFormData(prev => ({
        ...prev,
        ipd_pkg_price: selectedPackage.price,
        ipd_pkg_original_price: selectedPackage.price,
        ipd_pkg_discount: ''
    }));
};




// helper: robust parse of amounts coming from UI (handles "", "0.00", "1,234.56", null)
// robust number parser (handles "", "0.00", "1,234.56", null, etc.)
const toDateTimeLocal = (str) => {
  if (!str) return '';
  const s = String(str).replace(' ', 'T');
  // keep only up to minutes: YYYY-MM-DDTHH:mm
  return s.slice(0, 16);
};

const parseAmountSafe = (v) => {
  if (v === null || v === undefined) return 0;
  if (typeof v === 'number') return isFinite(v) ? v : 0;
  const s = String(v).trim();
  if (s === '') return 0;
  const cleaned = s.replace(/[^0-9.-]+/g, '');
  const n = parseFloat(cleaned);
  return isNaN(n) ? 0 : n;
};


// handleChange with ipd_type logic (set reg charges to 0 for Old)
// FIXED handleChange function - paste this to replace your existing handleChange


const UPPERCASE_FIELDS = new Set([
  'ipd_patient_name',
  'ipd_guardien_name',
  'ipd_address',
  'ipd_city',
  'ipd_remarks',
  'ipd_policy_name',
  'ipd_policy_address',
]);

const handleChange = (e) => {
  let { name, value } = e.target;
  if (UPPERCASE_FIELDS.has(name) && typeof value === 'string') {
    value = value.toUpperCase();
  }

  setFormData(prev => {
    let updatedData = { ...prev, [name]: value };

    // keep ipd_age (legacy) in sync from the 3 fields when any of them change
    if (name === 'ipd_age_year' || name === 'ipd_age_month' || name === 'ipd_age_day') {
      const y = (updatedData.ipd_age_year === '' || updatedData.ipd_age_year === null) ? '' : String(Math.max(0, Number(updatedData.ipd_age_year)));
      const m = (updatedData.ipd_age_month === '' || updatedData.ipd_age_month === null) ? '' : String(Math.max(0, Math.min(11, Number(updatedData.ipd_age_month))));
      const d = (updatedData.ipd_age_day === '' || updatedData.ipd_age_day === null) ? '' : String(Math.max(0, Math.min(30, Number(updatedData.ipd_age_day))));

      updatedData.ipd_age_year = y;
      updatedData.ipd_age_month = m;
      updatedData.ipd_age_day = d;

      const combined = formatAgeString(y, m, d);
      if (combined) updatedData.ipd_age = combined;
      else updatedData.ipd_age = prev.ipd_age || '';
    }
    if (name === "ipd_pkg_price") {
      // Keep raw string while typing
      updatedData.ipd_pkg_price = value;
    
      // ✅ Use prev (already available in setFormData callback) or define cur first
      const cur = (formRef && formRef.current) ? formRef.current : prev;
      
      const newPkgPrice = parseAmountSafeLocal(value, 0);
      const pkgDiscount = parseAmountSafeLocal(cur.ipd_pkg_discount, 0);
      const regVisible = parseAmountSafeLocal(cur.ipd_reg_charges, 0);
      const paidNow = parseAmountSafeLocal(cur.ipd_paid, 0);
    
      const subtotal = Math.max(0, regVisible + newPkgPrice - pkgDiscount);
      const due = Math.max(0, subtotal - paidNow);
    
      updatedData.ipd_total_price = Number(subtotal).toFixed(2);
      updatedData.ipd_due = Number(due).toFixed(2);
    }
    // Package discount (absolute) → adjust package price
    if (name === "ipd_pkg_discount") {
      const cur = (formRef && formRef.current) ? formRef.current : prev;
      
      const discount = parseFloat(value) || 0;
      const pkgPrice = parseFloat(cur.ipd_pkg_price) || 0;
      
      if (discount > pkgPrice) {
        updatedData.ipd_pkg_discount = pkgPrice;
      } else {
        updatedData.ipd_pkg_discount = value;
      }
      
      const finalDiscount = Math.min(discount, pkgPrice);
      const regVisible = parseAmountSafeLocal(cur.ipd_reg_charges, 0);
      const paidNow = parseAmountSafeLocal(cur.ipd_paid, 0);
      const subtotal = Math.max(0, regVisible + pkgPrice - finalDiscount);
      const due = Math.max(0, subtotal - paidNow);
      
      updatedData.ipd_total_price = Number(subtotal).toFixed(2);
      updatedData.ipd_due = Number(due).toFixed(2);
    }

    // ---------- ipd_discount (absolute amount) handler ----------
    if (name === "ipd_discount") {
      const raw = value === "" ? "" : String(value);
      updatedData.ipd_discount = raw;
    
      const cur = (formRef && formRef.current) ? formRef.current : prev;
      const discountAmt = raw === "" ? 0 : parseAmountSafeLocal(raw, 0);
      
      // Get original registration charge - check multiple sources
      let regOriginal = parseAmountSafeLocal(cur.ipd_reg_charges_original, 0);
      
      // If no original stored yet, use current reg charges as original
      if (!regOriginal || regOriginal === 0) {
        regOriginal = parseAmountSafeLocal(prev.ipd_reg_charges_original, 0);
      }
      if (!regOriginal || regOriginal === 0) {
        regOriginal = parseAmountSafeLocal(cur.ipd_reg_charges, 0);
      }
      if (!regOriginal || regOriginal === 0) {
        regOriginal = parseAmountSafeLocal(prev.ipd_reg_charges, 0);
      }
      
      // Store original if we found it and it's not already stored
      if (regOriginal > 0 && !prev.ipd_reg_charges_original) {
        updatedData.ipd_reg_charges_original = regOriginal;
      }
      
      // Package values
     // const pkgOriginal = parseAmountSafeLocal(cur.ipd_pkg_original_price, parseAmountSafeLocal(cur.ipd_pkg_price, 0));
     const pkgOriginal = parseAmountSafeLocal(
      cur.ipd_pkg_price,
      0
    );
     const pkgDiscount = parseAmountSafeLocal(cur.ipd_pkg_discount, 0);
      const paidNow = parseAmountSafeLocal(cur.ipd_paid, 0);
    
      // Apply discount to registration (capped at original amount)
      const appliedDiscount = Math.min(Math.max(0, discountAmt), regOriginal);
      const regVisible = Math.max(0, regOriginal - appliedDiscount);
      
      // Calculate subtotal and due
      const subtotal = Math.max(0, regVisible + pkgOriginal - pkgDiscount);
      const due = Math.max(0, subtotal - paidNow);
    
      updatedData.ipd_reg_charges = Number(regVisible).toFixed(2);
      updatedData.ipd_total_price = Number(subtotal).toFixed(2);
      updatedData.ipd_due = Number(due).toFixed(2);
    }

    // Title → auto gender
    else if (name === "ipd_patient_title") {
      if (value === "Mr." || value === "Master") updatedData.ipd_patient_gender = "Male";
      else updatedData.ipd_patient_gender = "Female";
    }

    else if (name === "ipd_type") {
      const prevRegOriginal = parseFloat(prev.ipd_reg_charges_original || prev.ipd_reg_charges || 0);
    
      // Store the original value if we don't have it yet
      if (!prev.ipd_reg_charges_original || prev.ipd_reg_charges_original === 0) {
        updatedData.ipd_reg_charges_original = prevRegOriginal || parseFloat(prev.ipd_reg_charges) || 0;
      } else {
        updatedData.ipd_reg_charges_original = prev.ipd_reg_charges_original;
      }
    
      // Set visible registration based on new type
      if (value === "Old") {
        updatedData.ipd_reg_charges = (0).toFixed(2);
      } else {
        // OPD or New Visit: use original
        updatedData.ipd_reg_charges = updatedData.ipd_reg_charges_original 
          ? Number(updatedData.ipd_reg_charges_original).toFixed(2) 
          : "0.00";
      }
    
      // Recalculate total
      const pkgPrice = parseFloat(prev.ipd_pkg_price) || 0;
      const pkgDiscountAmount = parseFloat(prev.ipd_pkg_discount) || 0;
      const regToUseNow = parseFloat(updatedData.ipd_reg_charges) || 0;
      let totalNow = (regToUseNow + pkgPrice ) - pkgDiscountAmount;
      if (!isFinite(totalNow) || totalNow < 0) totalNow = 0;
      updatedData.ipd_total_price = totalNow.toFixed(2);
    }


    else if (name === "ipd_paid" || name === "ipd_advance") {
      const cur = formRef.current || formData;
      const rawValue = value;
    
      let subtotal = parseAmountSafe(cur.ipd_total_price);
      if (!subtotal || subtotal === 0) {
        const regVisible = parseAmountSafe(cur.ipd_reg_charges);
        const pkgPrice = parseAmountSafe(cur.ipd_pkg_price);
        const pkgDiscountAmt = parseAmountSafe(cur.ipd_pkg_discount);
        subtotal = Math.max(0, regVisible + pkgPrice - pkgDiscountAmt);
      }
    
      if (name === "ipd_advance") {
        updatedData.ipd_advance = rawValue === "" ? "" : Number(parseAmountSafe(rawValue));
      }

      if (name === "ipd_paid") {
        if (rawValue === "") {
          updatedData.ipd_paid = "";
          const paidVal = 0;
          const advVal = parseAmountSafe(cur.ipd_advance);
          const newDue = Math.max(0, subtotal - paidVal - advVal);
          updatedData.ipd_due = isFinite(newDue) ? Number(newDue).toFixed(2) : "0.00";
        } else {
          const typedPaid = parseAmountSafe(rawValue);
          const maxAllowedPaid = Math.max(0, subtotal);

          if (typedPaid > maxAllowedPaid + 1e-9) {
            updatedData.ipd_paid = Number(maxAllowedPaid).toFixed(2);
            setTimeout(() => {
              Swal.fire({
                title: "Overpayment prevented",
                html: `Paid amount cannot exceed the total amount.<br><b>Max allowed Paid:</b> ₹${Number(maxAllowedPaid).toFixed(2)}`,
                icon: "warning",
                confirmButtonText: "OK"
              });
            }, 0);

            const advVal = parseAmountSafe(cur.ipd_advance);
            const newDue = Math.max(0, subtotal - parseAmountSafe(updatedData.ipd_paid) - advVal);
            updatedData.ipd_due = isFinite(newDue) ? Number(newDue).toFixed(2) : "0.00";
          } else {
            updatedData.ipd_paid = Number(typedPaid);
            const advVal = parseAmountSafe(cur.ipd_advance);
            const newDue = Math.max(0, subtotal - typedPaid - advVal);
            updatedData.ipd_due = isFinite(newDue) ? Number(newDue).toFixed(2) : "0.00";
          }
        }
      }
    }

    else if (name === "search_key") {
      initData();
    }

    return updatedData;
  });
};






const handleSubmit = async (e) => {
  e.preventDefault();



  if (!formData.ipd_ward) {
    toast.error("Please select a Ward before saving.");
    return;
  }

  if (!formData.ipd_bed) {
    toast.error("Please select a Bed before saving.");
    return;
  }
  // derive gender synchronously in a local object (avoid setState race)
  const title = (formData.ipd_patient_title || '').toLowerCase();
  let derivedGender = formData.ipd_patient_gender || '';
  if (!derivedGender) {
    if (title.includes('mr') || title.includes('master')) derivedGender = 'Male';
    else if (title.includes('miss') || title.includes('mrs') || title.includes('baby') || title.includes('ms')) derivedGender = 'Female';
    else derivedGender = 'Other';
  }

  // build a stable local copy used for validation/computation/payload
  const finalFormData = { ...formData, ipd_patient_gender: derivedGender };

  // optionally update UI state so user sees derived gender
  setFormData(prev => ({ ...prev, ipd_patient_gender: derivedGender }));

  // ---------- FIXED: Calculate registration charge correctly ----------
  
  // Get original registration charge (before any discount)
  const regOriginalNum = parseFloat(finalFormData.ipd_reg_charges_original) || 0;
  
  // Get visible registration charge (may have discount applied)
  const regVisibleNum = parseFloat(finalFormData.ipd_reg_charges);
  
  // Get discount amount
  const discountAmt = parseFloat(finalFormData.ipd_discount) || 0;

  // Determine the registration charge to send
  const regRequired = (() => {
    // For "Old" type, registration is always 0
    if (finalFormData.ipd_type === "Old") return 0;
    
    // For other types, use visible if valid, else calculate from original - discount
    if (Number.isFinite(regVisibleNum) && regVisibleNum >= 0) {
      return regVisibleNum;
    }
    
    // Fallback: calculate from original minus discount
    if (regOriginalNum > 0) {
      return Math.max(0, regOriginalNum - discountAmt);
    }
    
    return 0;
  })();

  // ✅ KEY FIX: If regRequired is 0 but we have an original and type is NOT "Old",
  // something is wrong - use the original
  const regToSend = (() => {
    if (finalFormData.ipd_type === "Old") return 0;
    if (regRequired > 0) return regRequired;
    if (regOriginalNum > 0 && discountAmt === 0) return regOriginalNum;
    return regRequired;
  })();

  console.log('Registration calculation:', {
    regOriginalNum,
    regVisibleNum,
    discountAmt,
    regRequired,
    regToSend,
    type: finalFormData.ipd_type
  });

  const paidNow = parseFloat(finalFormData.ipd_paid) || 0;
  const advanceGiven = parseFloat(finalFormData.ipd_advance) || 0;

  // Calculate subtotal
  //const pkgOriginal = parseFloat(finalFormData.ipd_pkg_original_price) || parseFloat(finalFormData.ipd_pkg_price) || 0;
  const pkgPrice =
  parseFloat(finalFormData.ipd_pkg_price) || 0;
  const pkgDiscount = parseFloat(finalFormData.ipd_pkg_discount) || 0;
  
  //const subtotal = Math.max(0, regToSend + pkgOriginal - pkgDiscount);
  const subtotal = regToSend + pkgPrice - pkgDiscount;
  // Registration payment warning (optional - you can keep or remove)
  if (paidNow < regToSend && regToSend > 0) {
    const regDue = regToSend - paidNow;
    
    const { isConfirmed } = await Swal.fire({
      title: "Registration Due Pending!",
      html: `
        <div style="text-align: left; padding: 10px;">
          <p><strong>Registration Amount:</strong> ₹${Number(regToSend).toFixed(2)}</p>
          <p><strong>Paid Now:</strong> ₹${Number(paidNow).toFixed(2)}</p>
          <p><strong>Registration Due:</strong> <span style="color: #d9534f;">₹${regDue.toFixed(2)}</span></p>
          <hr>
          <p style="color: #d9534f;"><strong>⚠️ Warning:</strong> Registration charges are not fully paid.</p>
          <p>Are you sure you want to proceed with this registration?</p>
        </div>
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Proceed",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#d9534f",
      cancelButtonColor: "#6c757d",
    });

    if (!isConfirmed) {
      return;
    }
  }

  // ensure paid does not exceed subtotal
  const maxPaidAllowed = Math.max(0, subtotal);
  if (paidNow > maxPaidAllowed) {
    Swal.fire({
      title: "Invalid Paid Amount",
      html: `Paid amount cannot exceed the total amount.<br><b>Max allowed Paid:</b> ₹${Number(maxPaidAllowed).toFixed(2)}`,
      icon: "warning",
      confirmButtonText: "OK",
    });
    return;
  }

  // Calculate due = subtotal - paid
  const computedDue = Math.max(0, subtotal - paidNow);

  console.log('Payment calculation:', {
    subtotal,
    paidNow,
    advanceGiven,
    computedDue
  });

  // --- Build FormData ---
  const fd = new FormData();
  
  // ✅ Send correct registration charge
  fd.append('ipd_reg_charges', Number(regToSend).toFixed(2));
  
  // ✅ Always send original registration charge
  fd.append('ipd_reg_charges_original', Number(regOriginalNum || regToSend).toFixed(2));
  
  // Other fields
  fd.append('ipd_id', finalFormData.ipd_id || "");
  fd.append('ipd_patient_title', finalFormData.ipd_patient_title);
  fd.append('ipd_patient_name', finalFormData.ipd_patient_name);
  fd.append('ipd_patient_gender', finalFormData.ipd_patient_gender);
  fd.append('ipd_patient_mobile', finalFormData.ipd_patient_mobile);
  fd.append('ipd_guardien_title', finalFormData.ipd_guardien_title);
  fd.append('ipd_guardien_name', finalFormData.ipd_guardien_name);
  fd.append('ipd_address', finalFormData.ipd_address);
  fd.append('ipd_city', finalFormData.ipd_city);
  fd.append('ipd_age', finalFormData.ipd_age);
  fd.append('ipd_age_year', finalFormData.ipd_age_year || '');
  fd.append('ipd_age_month', finalFormData.ipd_age_month || '');
  fd.append('ipd_age_day', finalFormData.ipd_age_day || '');
  fd.append('ipd_type', finalFormData.ipd_type);
  fd.append('ipd_specality', finalFormData.ipd_specality);
  fd.append('ipd_refer_doctor', finalFormData.ipd_refer_doctor);
  fd.append('ipd_file_number', finalFormData.ipd_file_number);
  fd.append('ipd_attachment', finalFormData.ipd_attachment);
  fd.append('ipd_reg_date', finalFormData.ipd_reg_date);
  fd.append('ipd_datetime', finalFormData.ipd_datetime || finalFormData.ipd_reg_date);
  fd.append('ipd_policy_name', finalFormData.ipd_policy_name);
  fd.append('ipd_policy_no', finalFormData.ipd_policy_no);
  fd.append('ipd_policy_address', finalFormData.ipd_policy_address);
  fd.append('ipd_case', finalFormData.ipd_case);
  fd.append('ipd_mlc_number', finalFormData.ipd_mlc_number);
  fd.append('ipd_cont_number', finalFormData.ipd_cont_number);
  fd.append('ipd_ward', finalFormData.ipd_ward);
  fd.append('ipd_bed', finalFormData.ipd_bed);
  fd.append('ipd_bed_price', finalFormData.ipd_bed_price);
  fd.append('ipd_price', finalFormData.ipd_price);
  fd.append('ipd_pkg', finalFormData.ipd_pkg);
  fd.append('ipd_pkg_price', finalFormData.ipd_pkg_price);
  fd.append('ipd_pkg_discount', finalFormData.ipd_pkg_discount || 0);
  fd.append('ipd_total_price', Number(subtotal).toFixed(2));
  fd.append('ipd_discount', finalFormData.ipd_discount || 0);
  fd.append('ipd_paid', paidNow);
  fd.append('ipd_advance', advanceGiven);
  fd.append('ipd_due', Number(computedDue).toFixed(2));
  fd.append('ipd_pay_mode', finalFormData.ipd_pay_mode || "cash");
  fd.append('ipd_remarks', finalFormData.ipd_remarks);
  fd.append('ipd_user', ldata?.user_id || 1);
  fd.append('ipd_uhid', finalFormData.ipd_uhid || "");

  // Broker fields
  const brokerIdsArr = selectedBrokers.map(b => b.value);
  const brokerNamesArr = selectedBrokers.map(b => (b.name || b.label || '').replace(/\s*\(.*\)\s*$/, '').trim());
   
  fd.append('broker_ids', JSON.stringify(brokerIdsArr));
  fd.append('broker_names', JSON.stringify(brokerNamesArr));
  fd.append('broker_id', brokerIdsArr.join(','));
  fd.append('broker_name', brokerNamesArr.join(', '));
  fd.append('ipd_broker_id', brokerIdsArr.join(','));
  fd.append('ipd_broker_name', brokerNamesArr.join(', '));


  if (finalFormData.ipd_type === "Old" || finalFormData.ipd_type === "OPD") {
    fd.append("opd_uhid_move", (finalFormData.ipd_uhid || "").trim());
  }

  try {
    const response = await axios.post(
      AppConst.BASE_URL + AppConst.addIpdUrl,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    if (response.data.status) {
      const ipdResp = response.data.ipd_dt || {};

      if (formData.ipd_id && originalRecord) {
        try {
            const logFd = new FormData();
            logFd.append('record_id', formData.ipd_id);
            logFd.append('old_data', JSON.stringify(originalRecord));
            logFd.append('remarks', 'IPD record updated');
            attachUserInfo(logFd);
            
            await axios.post(
                AppConst.BASE_URL + AppConst.logEditIpdUrl,
                logFd,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
            console.log("✅ IPD edit logged");
        } catch (logErr) {
            console.warn("⚠️ Audit log failed (non-critical):", logErr);
        }
    }


      // Handle broker response
      try {
        const srv = ipdResp || response.data || {};
        const retIdRaw = String(srv.ipd_broker_id ?? srv.broker_id ?? '').trim();
        const retNameRaw = String(srv.ipd_broker_name ?? srv.broker_name ?? '').trim();
       
        if (retIdRaw || retNameRaw) {
          const ids = retIdRaw.split(',').map(s => s.trim()).filter(Boolean);
          const names = retNameRaw.split(',').map(s => s.trim()).filter(Boolean);
          const newSels = ids.map((id, i) => ({
            value: id, label: names[i] || id, name: names[i] || id, phone: '', raw: srv
          }));
          if (newSels.length > 0) setSelectedBrokers(newSels);
        }
      } catch (e) {
        console.warn("Applying returned broker to UI failed:", e);
      }

      const ipdId = ipdResp.ipd_id || ipdResp.id || response.data.id || finalFormData.ipd_id || null;

      try {
        if (ipdId) {
          await loadIpdForEdit(ipdId);
        } else {
          setFormData((prev) => ({
            ...prev,
            ipd_uhid: ipdResp.ipd_uhid ?? prev.ipd_uhid,
            ipd_advance: ipdResp.ipd_advance ?? prev.ipd_advance,
            ipd_paid: ipdResp.ipd_paid ?? prev.ipd_paid,
            ipd_due: ipdResp.ipd_due ?? prev.ipd_due,
            ipd_reg_charges: ipdResp.ipd_reg_charges ?? prev.ipd_reg_charges,
            ipd_reg_charges_original: ipdResp.ipd_reg_charges_original ?? prev.ipd_reg_charges_original,
            ipd_discount: ipdResp.ipd_discount ?? prev.ipd_discount,
          }));
        }

        setIsSaved(true);

        // WhatsApp notification handling
        const whatsappStatus = response.data.whatsapp_status;
        const whatsappMessage = response.data.whatsapp_message;

        if (whatsappStatus === 'sent') {
          await Swal.fire({
            title: "Success!",
            html: "IPD admission saved successfully.<br>✅ WhatsApp notification sent to patient.",
            icon: "success",
            confirmButtonText: "OK",
          });
        } else {
          await Swal.fire({
            title: "Success!",
            text: "IPD admission saved successfully.",
            icon: "success",
            confirmButtonText: "OK",
          });
        }

      } catch (reloadErr) {
        console.error("Reload after save failed", reloadErr);
        setIsSaved(true);
        Swal.fire({
          title: "Saved (partial)",
          html: "Record saved on server, but the UI failed to refresh with the latest data.",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    } else {
      Swal.fire({
        title: "Error!",
        text: response.data.success || "Failed to save IPD admission.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  } catch (err) {
    console.error("Save IPD error", err);
    Swal.fire({
      title: "Error!",
      text: "Something went wrong while saving IPD admission.",
      icon: "error",
      confirmButtonText: "OK",
    });
  }
};


const initData = async () => {
    const storedData = sessionStorage.getItem("ldata");
    if (storedData) {
        const parsed = JSON.parse(storedData);
        var fd = new FormData();
        fd.append('page_no', "0");
        fd.append('search_key', formData.search_key + "");
        fd.append('test_user', 1 + "");
        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.getTestListUrl, fd, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            if (response.data.status) {

                var records = response.data.records;
                if (records != null && records != undefined) {
                    setFormData(prev => ({
                        ...prev,
                        tests: records
                    }));
                    // if tests1 not set yet, initialize it
if (!formData.tests1 || formData.tests1.length <= 0) {
    setFormData(prev => ({
        ...prev,
        tests1: records
    }));
}

                }
            }
        } catch (error) {

        }

        fd = new FormData();
        fd.append('cat_type', "vital");
        fd.append('page_no', "none");
        fd.append('search_key', "");
        fd.append('par_by', 1 + "");
        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            if (response.data.status) {

                var records = response.data.records;
                if (records != null && records != undefined) {
                    setFormData(prev => ({
                        ...prev,
                        vitals: records
                    }));
                }
            }
        } catch (error) {

        }

        const fd0 = new FormData();
        fd0.append('cat_type', "speciality");
        fd0.append('page_no', "none");
        fd0.append('par_by', 1 + "");
        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd0, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            });
            if (response.data.status) {

            var records = response.data.records;
            if (records != null && records != undefined) {
                setFormData(prev => ({
                ...prev,
                cats: records
                }));
            }
            }
        } catch (error) {

        }
        
        try {
             const fd0w = new FormData();
        fd0w.append('cat_type', "ward");
        fd0w.append('page_no', "none");
        fd0w.append('par_by', 1 + "");
            const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd0w, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            });
            if (response.data.status) {

            var records = response.data.records;
            if (records != null && records != undefined) {
                setFormData(prev => ({
                ...prev,
                wards: records
                }));
            }
            }
        } catch (error) {

        }
        
         try {
             const fd0w = new FormData();
        fd0w.append('cat_type', "package");
        fd0w.append('page_no', "none");
        fd0w.append('par_by', 1 + "");
            const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd0w, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            });
            if (response.data.status) {

            var records = response.data.records;
            if (records != null && records != undefined) {
                 var vl = records[0].cat_type1;
                setFormData(prev => ({
                ...prev,
                pkgs: records,
                ipd_pkg_price: 0
                }));

            }
            }
        } catch (error) {

        }


  
  
  
  
        const fd00 = new FormData();
fd00.append('cat_type', "hospCharge");
fd00.append('cat_name', "IPD Fees");
fd00.append('page_no', "none");
fd00.append('par_by', 1 + "");

try {
    const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd00, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    
    if (response.data.status) {
        var records = response.data.records;
        
        if (records != null && records != undefined && records.length > 0) {
            // ✅ Filter for exact match instead of using index
            const ipdFeesRecord = records.find(record => 
                record.cat_name === "IPD Fees" || 
                record.cat_name.toLowerCase() === "ipd fees"
            );
            
            if (ipdFeesRecord) {
                const regBase = parseFloat(ipdFeesRecord.cat_type1) || 0;
                setFormData(prev => ({
                    ...prev,
                    ipd_reg_charges: regBase.toFixed(2),
                    ipd_reg_charges_original: regBase,
                }));
            } else {
                console.warn('IPD Fees record not found in response');
            }
        }
    }
} catch (error) {
    console.error('Error loading IPD Fees:', error);
}
    }
};



const fetchInsuranceOptions = async () => {
  try {
    const fd = new FormData();
    fd.append('page_no', 'none');
    fd.append('search_key', '');
    const res = await axios.post(AppConst.BASE_URL + AppConst.getInsuranceListUrl, fd, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    const rec = res?.data?.records ?? res?.data?.list ?? [];
    if (Array.isArray(rec)) {
      const opts = rec.map(r => ({
        value: r.id, // insurance id
        label: `${r.insurance_name || ''}`,
        raw: r
      }));
      setInsuranceOptions(opts);
    } else {
      setInsuranceOptions([]);
    }
  } catch (err) {
    console.error('fetchInsuranceOptions', err);
    setInsuranceOptions([]);
  }
};

const fetchTpaOptions = async (insuranceId = null) => {
  try {
    const fd = new FormData();
    // If your API supports filtering by insurance_id send it; otherwise backend can filter or we will fetch all
    if (insuranceId) fd.append('insurance_id', insuranceId + '');
    fd.append('page_no', 'none');
    fd.append('search_key', '');
    const res = await axios.post(AppConst.BASE_URL + (AppConst.getTpaListUrl ?? AppConst.getTpaListUrl), fd, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    const rec = res?.data?.records ?? res?.data?.list ?? [];
    if (Array.isArray(rec)) {
      const opts = rec.map(r => ({
        value: r.id,  // tpa id
        label: `${r.tpa_name || ''}${r.amount ? ' (₹' + r.amount + ')' : ''}`,
        raw: r
      }));
      setTpaOptions(opts);
    } else {
      setTpaOptions([]);
    }
  } catch (err) {
    console.error('fetchTpaOptions', err);
    setTpaOptions([]);
  }
};



// put this near top-level of component (not inside initData)
const fetchCaseList = async () => {
    try {
      const fd = new FormData();
      fd.append('cat_type', 'case');
      fd.append('page_no', 'none');
      fd.append('par_by', 1 + '');

  
      console.log("fetchCaseList: requesting case list...");
      const resp = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      console.log("fetchCaseList response:", resp?.data);
  
      if (resp && resp.data && resp.data.status && Array.isArray(resp.data.records)) {
        setFormData(prev => ({ ...prev, cases: resp.data.records }));
        return resp.data.records;
      } else {
        console.warn("fetchCaseList: no records or status false", resp?.data);
        setFormData(prev => ({ ...prev, cases: [] }));
        return [];
      }
    } catch (err) {
      console.error("fetchCaseList error", err);
      setFormData(prev => ({ ...prev, cases: [] }));
      return [];
    }
  };
 
  


  
// ---------- NEW: load beds for a ward (ensures bedSearch + price available) ----------
// ---------- FIXED: load beds for a ward (only show status=0, but include current bed when editing) ----------
const initData2ForWard = async (wardId, selectedBedId = null, currentIpdId = null) => {
  if (!wardId) {
    setFormData(prev => ({ ...prev, beds: [] }));
    return;
  }
  try {
    const fd0w = new FormData();
    fd0w.append('bed_ward', wardId);
    fd0w.append('page_no', "none");
    fd0w.append('bed_user', 1 + "");
    
    // Pass current IPD user ID when editing
    if (currentIpdId) {
      fd0w.append('current_ipd_user', currentIpdId);
    }

    const response = await axios.post(AppConst.BASE_URL + AppConst.getBedListUrl, fd0w, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    if (response.data.status) {
      const records = response.data.records || [];
      
      // ✅ FIXED: Filter beds - only show status = 0 (available)
      // BUT also include the currently selected bed (for editing existing IPD)
      const filteredBeds = records.filter(b => {
        // Show if bed is available (status = 0)
        if (String(b.status) === "0" || b.status === 0) {
          return true;
        }
        
        // Also show if this is the currently assigned bed (for editing)
        if (selectedBedId && String(b.bed_id) === String(selectedBedId)) {
          return true;
        }
        
        // Hide occupied beds (status = 1)
        return false;
      });
      
      console.log("📋 Total beds from API:", records.length);
      console.log("📋 Available beds (status=0):", filteredBeds.length);
      console.log("📋 Selected bed ID:", selectedBedId);
      
      setFormData(prev => ({ ...prev, beds: filteredBeds }));

      if (selectedBedId) {
        const sel = filteredBeds.find(b => String(b.bed_id) === String(selectedBedId));
        if (sel) {
          console.log('✅ Setting bed name from initData2ForWard:', sel.bed_name);
          setBedSearch(sel.bed_name || "");
          setFormData(prev => ({ ...prev, ipd_bed_price: sel.bed_price || prev.ipd_bed_price }));
        } else {
          console.warn('⚠️ Bed not found in filtered records:', selectedBedId);
          // Try to find in original records (in case it was filtered out)
          const originalBed = records.find(b => String(b.bed_id) === String(selectedBedId));
          if (originalBed) {
            console.log('ℹ️ Bed found in original records but filtered out (occupied):', originalBed.bed_name);
            // Add this bed back to the list for editing purposes
            setFormData(prev => ({ 
              ...prev, 
              beds: [...filteredBeds, originalBed],
              ipd_bed_price: originalBed.bed_price || prev.ipd_bed_price 
            }));
            setBedSearch(originalBed.bed_name || "");
          }
        }
      }
    }
  } catch (err) {
    console.error('Error loading beds for ward', err);
  }
};

// thin wrapper to keep previous calls working
const initData2 = async () => {
  await initData2ForWard(formData.ipd_ward);
};
// ---------- Selection handlers (ensure these are defined) ----------
const handlePkgSelect = (pkgId) => {
    const selectedPkg = formData.pkgs.find(p => String(p.cat_id) === String(pkgId));
    setFormData(prev => ({
      ...prev,
      ipd_pkg: pkgId,
      ipd_pkg_price: selectedPkg ? selectedPkg.cat_type1 : "0",
      ipd_pkg_original_price: selectedPkg ? selectedPkg.cat_type1 : prev.ipd_pkg_original_price,
      ipd_pkg_discount: '' // reset discount when selecting new pkg
    }));
    setPkgSearch("");
    setShowPkgOptions(false);
  };
  
  const handleWardSelect = (wardId) => {
    setFormData(prev => ({
      ...prev,
      ipd_ward: wardId,
      ipd_bed: "",
      ipd_bed_price: "",
    }));
    setWardSearch("");
    setBedSearch("");
    setShowWardOptions(false);
  
    // load beds for this ward
    initData2ForWard(wardId);
  };
  
  const handleBedSelect = (bedId) => {
    const selectedBed = formData.beds.find(b => String(b.bed_id) === String(bedId));
    setFormData(prev => ({
      ...prev,
      ipd_bed: bedId,
      ipd_bed_price: selectedBed ? selectedBed.bed_price : "0",
    }));
    setBedSearch("");
    setShowBedOptions(false);
  };
  
  const handleCaseSelect = (caseId) => {
    // store id as string for consistent comparisons
    setFormData(prev => ({ ...prev, ipd_case: caseId ? String(caseId) : "" }));
    // set visible label
    const local = (formData.cases || []).find(c => String(c.cat_id) === String(caseId));
    if (local) {
      setCaseSearch(local.cat_name || "");
    } else {
      // fallback – display whatever user clicked (if not in local list)
      setCaseSearch(String(caseId));
      // also attempt to fetch case details (optional)
      (async () => {
        try {
          const fd = new FormData();
          fd.append('cat_id', caseId);
          const resp = await axios.post(AppConst.BASE_URL + AppConst.getCatByIdUrl, fd);
          if (resp && resp.data && resp.data.status && resp.data.cat_dt) {
            // update local cases list so next time find works
            setFormData(prev => {
              const existing = Array.isArray(prev.cases) ? [...prev.cases] : [];
              const idx = existing.findIndex(x => String(x.cat_id) === String(resp.data.cat_dt.cat_id));
              if (idx === -1) existing.push(resp.data.cat_dt);
              else existing[idx] = { ...existing[idx], ...resp.data.cat_dt };
              return { ...prev, cases: existing };
            });
            setCaseSearch(resp.data.cat_dt.cat_name || "");
          }
        } catch (err) {
          console.warn("Failed to fetch case by id", err);
        }
      })();
    }
    setShowCaseOptions(false);
  };
 
  
// --- PASTE HERE: selection handlers (place after handleBedSelect / handleCaseSelect) ---
const handleInsuranceChange = (opt) => {
  setSelectedInsurance(opt || null);
  const raw = opt ? opt.raw : null;
  setFormData(prev => ({
    ...prev,
    ipd_insurance_id: opt ? String(opt.value) : '',
    ipd_policy_name: raw ? (raw.insurance_name || '') : '',
    ipd_policy_address: raw ? (raw.insurance_address || '') : ''
  }));
  // fetch TPAs for that insurance if backend supports filtering by insurance_id
  fetchTpaOptions(opt ? opt.value : null);
  // clear selected TPA when insurance changed
  setSelectedTpa(null);
  setFormData(prev => ({ ...prev, ipd_tpa_id: '', ipd_policy_no: '' }));
};

const handleTpaChange = (opt) => {
  setSelectedTpa(opt || null);
  const raw = opt ? opt.raw : null;
  setFormData(prev => ({
    ...prev,
    ipd_tpa_id: opt ? String(opt.value) : '',
    // ipd_policy_no currently used for TPA identifier/name in your formData.
    // If your backend expects a separate field for TPA id, adjust accordingly.
    ipd_policy_no: raw ? (raw.tpa_name || String(opt.value)) : (opt ? String(opt.value) : '')
  }));
};
// --- END PASTE ---


  
// ensure pkg price when ipd_pkg changes (unchanged)
useEffect(() => {
    for(var x=0;x<formData.pkgs.length;x++){
        if(formData.pkgs[x].cat_id.localeCompare(formData.ipd_pkg)==0){
            
            var vl = formData.pkgs[x].cat_type1;
             setFormData(prev => ({
                ...prev,
                ipd_pkg_price: vl,
                ipd_pkg_original_price: vl,
            }));
        }
    }
}, [formData.ipd_pkg]);




// ---------- NEW: load single ipd record and populate form (ids + visible names) ----------
// FIXED loadIpdForEdit function
// Replace your existing loadIpdForEdit function with this

const loadIpdForEdit = async (ipd_id) => {
  setIsReloading(true);
  try {
    const fd = new FormData();
    fd.append('ipd_id', ipd_id);
    const res = await axios.post(AppConst.BASE_URL + AppConst.getIpdByIdUrl, fd, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    if (res.data.status && res.data.ipd_dt) {
      const ipd = res.data.ipd_dt;
      setOriginalRecord(ipd); 
      // determine age parts — prefer explicit fields returned by backend if available
      let loadedYear = '';
      let loadedMonth = '';
      let loadedDay = '';

      // if server returned separate fields, use them
      if (ipd.ipd_age_year !== undefined && ipd.ipd_age_year !== null) loadedYear = String(ipd.ipd_age_year);
      if (ipd.ipd_age_month !== undefined && ipd.ipd_age_month !== null) loadedMonth = String(ipd.ipd_age_month);
      if (ipd.ipd_age_day !== undefined && ipd.ipd_age_day !== null) loadedDay = String(ipd.ipd_age_day);

      // fallback: try to parse ipd.ipd_age string like "30 Years / 2 Months / 5 Days" or "30-2-5" or "30"
      if (!loadedYear && ipd.ipd_age) {
        const raw = String(ipd.ipd_age);
        const dashMatch = raw.match(/^(\d{1,3})\s*[-\/]\s*(\d{1,2})\s*[-\/]\s*(\d{1,2})$/);
        if (dashMatch) {
          loadedYear = dashMatch[1];
          loadedMonth = dashMatch[2];
          loadedDay = dashMatch[3];
        } else {
          const nums = raw.match(/\d+/g) || [];
          if (nums.length === 3) {
            [loadedYear, loadedMonth, loadedDay] = nums;
          } else if (nums.length === 1) {
            loadedYear = nums[0];
          } else if (nums.length === 2) {
            loadedYear = nums[0];
            loadedMonth = nums[1];
          }
        }
      }

      setFormData(prev => {
        // --- Prepare numeric values from DB (safe parsing) ---
        let loadedRegOriginal = null;

        // 1) Prefer explicit original value from server if present and numeric
        if (ipd.ipd_reg_charges_original !== undefined && ipd.ipd_reg_charges_original !== null && ipd.ipd_reg_charges_original !== '') {
          loadedRegOriginal = sanitizeNumber(ipd.ipd_reg_charges_original, null);
        }

        // parse visible reg and discount from server (if present)
        const visibleReg = sanitizeNumber(ipd.ipd_reg_charges, null); // may be null
        const rawDisc = (ipd.ipd_discount !== undefined && ipd.ipd_discount !== null && ipd.ipd_discount !== '') 
          ? Number(String(ipd.ipd_discount).replace(/[^0-9.-]+/g,''))
          : null;

        const server = res.data.ipd_dt || {};

        // 2) If original not provided, try reconstructing
        if (loadedRegOriginal === null) {
          if (visibleReg !== null) {
            // 2a) Try treat discount as absolute rupee amount: original = visible + discount
            if (rawDisc !== null && !Number.isNaN(rawDisc)) {
              const possibleOriginal = visibleReg + rawDisc;
              if (isFinite(possibleOriginal) && possibleOriginal >= visibleReg) {
                loadedRegOriginal = Math.round(possibleOriginal * 100) / 100;
              } else {
                // 2b) Fallback: try treat discount as percentage: original = visible / (1 - pct/100)
                if (rawDisc > 0 && rawDisc < 100) {
                  const maybeOriginal = visibleReg / (1 - rawDisc / 100);
                  if (isFinite(maybeOriginal) && maybeOriginal > 0) {
                    loadedRegOriginal = Math.round(maybeOriginal * 100) / 100;
                  }
                }
              }
            }

            // 2c) If no discount info or reconstruction failed, use visible as original (safe fallback)
            if (loadedRegOriginal === null) {
              loadedRegOriginal = visibleReg;
            }
          }
        }

        // 3) final fallback: previous state's original or 0
        if (loadedRegOriginal === null) {
          loadedRegOriginal = prev.ipd_reg_charges_original || 0;
        }

       

        // Get the type from server
        const loadedType = sanitizeStr(ipd.ipd_type) || prev.ipd_type;
  const dbRegCharges = sanitizeNumber(ipd.ipd_reg_charges, null);
  const dbRegOriginal = sanitizeNumber(ipd.ipd_reg_charges_original, null);
  const dbDiscount = sanitizeNumber(ipd.ipd_discount, 0);
  
  let regOriginalValue, regVisibleValue;
  
  // Determine original
  if (dbRegOriginal !== null && dbRegOriginal > 0) {
    regOriginalValue = dbRegOriginal;
  } else if (dbRegCharges !== null && dbRegCharges > 0) {
    // If no original stored, use reg_charges + discount as original
    regOriginalValue = dbRegCharges + dbDiscount;
  } else {
    regOriginalValue = prev.ipd_reg_charges_original || 0;
  }
  
  // Determine visible
  if (loadedType === "Old") {
    regVisibleValue = 0;
  } else if (dbRegCharges !== null) {
    regVisibleValue = dbRegCharges;
  } else {
    regVisibleValue = Math.max(0, regOriginalValue - dbDiscount);
  }
        



        
        // IMPORTANT: Also ensure loadedRegOriginal is preserved if server doesn't return it
        if (loadedRegOriginal === null || loadedRegOriginal === 0) {
          // Try to get from visible registration if original not available
          const visibleAsOriginal = sanitizeNumber(ipd.ipd_reg_charges, null);
          const discountAmt = sanitizeNumber(ipd.ipd_discount, 0);
          
          if (visibleAsOriginal !== null && discountAmt > 0) {
            // Reconstruct: original = visible + discount
            loadedRegOriginal = visibleAsOriginal + discountAmt;
          } else if (visibleAsOriginal !== null && visibleAsOriginal > 0) {
            loadedRegOriginal = visibleAsOriginal;
          }
        }
        

        // package numbers
        const loadedPkgPrice = sanitizeNumber(ipd.ipd_pkg_price, null);
        const loadedPkgOriginal = (sanitizeNumber(ipd.ipd_pkg_original_price, null) !== null)
          ? sanitizeNumber(ipd.ipd_pkg_original_price, null)
          : (loadedPkgPrice !== null ? loadedPkgPrice : (prev.ipd_pkg_original_price || 0));
        const loadedPkgDiscount = sanitizeNumber(ipd.ipd_pkg_discount, 0) || 0;

        // total: prefer DB total if present, else compute from reg + pkg - pkgDiscount
        const loadedTotal = sanitizeNumber(ipd.ipd_total_price, null);
        const computedTotal = (loadedTotal !== null)
          ? loadedTotal
          : Math.max(0, Number(regVisibleValue || 0) + Number(loadedPkgOriginal || 0) - Number(loadedPkgDiscount || 0));

        // payments: normalize advance/paid/due
        const advNum = sanitizeNumber(ipd.ipd_advance, prev.ipd_advance || 0) || 0;
        const paidNum = sanitizeNumber(ipd.ipd_paid, prev.ipd_paid || 0) || 0;
        let dueNum;
        const dbDue = sanitizeNumber(ipd.ipd_due, null);
        if (dbDue !== null && dbDue >= 0) {
          dueNum = dbDue;
        } else {
          // Compute due = total - paid (advance is stored separately)
          dueNum = Math.max(0, computedTotal - paidNum);
        }

        // discount: keep as string for input display if present
        const discountVal = (ipd.ipd_discount !== undefined && ipd.ipd_discount !== null)
          ? String(ipd.ipd_discount)
          : (prev.ipd_discount !== undefined ? prev.ipd_discount : '');

        return {
          ...prev,

          // Identification / basic
          ipd_id: sanitizeStr(ipd.ipd_id),
          ipd_display_no: sanitizeStr(ipd.ipd_display_no), 
          ipd_uhid: sanitizeStr(ipd.ipd_uhid),
          ipd_patient_name: sanitizeStr(ipd.ipd_patient_name),
          ipd_patient_title: sanitizeStr(ipd.ipd_patient_title) || prev.ipd_patient_title,
          ipd_patient_gender: sanitizeStr(ipd.ipd_patient_gender) || prev.ipd_patient_gender,
          ipd_patient_mobile: sanitizeStr(ipd.ipd_patient_mobile),
          ipd_guardien_name: sanitizeStr(ipd.ipd_guardien_name),
          ipd_address: sanitizeStr(ipd.ipd_address),
          ipd_city: sanitizeStr(ipd.ipd_city),
          ipd_age: sanitizeStr(ipd.ipd_age),
          ipd_age_year: loadedYear,
          ipd_age_month: loadedMonth,
          ipd_age_day: loadedDay,
          ipd_type: loadedType,
          ipd_specality: sanitizeStr(ipd.ipd_specality),
          ipd_refer_doctor: sanitizeStr(ipd.ipd_refer_doctor),
          ipd_file_number: sanitizeStr(ipd.ipd_file_number || ipd.file_number || prev.ipd_file_number || ""),
          ipd_reg_date: sanitizeStr(ipd.ipd_reg_date) || prev.ipd_reg_date,

          // Ward / bed / package
          ipd_ward: sanitizeStr(ipd.ipd_ward),
          ipd_bed: sanitizeStr(ipd.ipd_bed),
          ipd_bed_price: sanitizeNumber(ipd.ipd_bed_price, prev.ipd_bed_price),

          ipd_pkg: sanitizeStr(ipd.ipd_pkg),
          ipd_pkg_price: (loadedPkgPrice !== null ? loadedPkgPrice : (prev.ipd_pkg_price || 0)),
          ipd_pkg_original_price: loadedPkgOriginal,
          ipd_pkg_discount: (ipd.ipd_pkg_discount === null || ipd.ipd_pkg_discount === undefined) ? '' : sanitizeNumber(ipd.ipd_pkg_discount, 0),

          // Case + Insurance
          ipd_case: String(server.ipd_case ?? server.case_id ?? server.cat_id ?? prev.ipd_case ?? ""),
          ipd_policy_name: String(server.ipd_policy_name ?? server.policy_name ?? server.insurance_name ?? prev.ipd_policy_name ?? ""),
          ipd_policy_no: String(server.ipd_policy_no ?? server.policy_no ?? server.tpa ?? prev.ipd_policy_no ?? ""),
          ipd_policy_address: String(server.ipd_policy_address ?? server.policy_address ?? server.insurance_address ?? prev.ipd_policy_address ?? ""),

          // ========== CRITICAL: Store both original AND visible correctly ==========
          ipd_total_price: String(Number(computedTotal).toFixed(2)),
          ipd_reg_charges_original: Number(regOriginalValue),
          ipd_reg_charges: Number(regVisibleValue).toFixed(2),

          // Discount should show in the input (editable)
          ipd_discount: discountVal,

          // Payments normalized as strings (2 decimals)
          ipd_advance: String(Number(advNum).toFixed(2)),
          ipd_advance_original: String(Number(advNum).toFixed(2)),
          ipd_paid: String(Number(paidNum).toFixed(2)),
          ipd_due: String(Number(dueNum).toFixed(2)),
          ipd_total_paid: String(Number(sanitizeNumber(ipd.ipd_total_paid, 0)).toFixed(2)),
          
          // Other fields
          ipd_pay_mode: sanitizeStr(ipd.ipd_pay_mode) || prev.ipd_pay_mode,
          ipd_remarks: sanitizeStr(ipd.ipd_remarks),
        };
      });

      // ===== BROKER LOADING =====
      // const serverBrokerId = String(ipd.ipd_broker_id ?? '').trim();
      // const serverBrokerName = String(ipd.ipd_broker_name ?? '').trim();

      // console.log('Loading broker from IPD:', { serverBrokerId, serverBrokerName });


      const serverBrokerIdRaw = String(ipd.ipd_broker_id ?? '').trim();
const serverBrokerNameRaw = String(ipd.ipd_broker_name ?? '').trim();
 
if (serverBrokerIdRaw || serverBrokerNameRaw) {
  const ids = serverBrokerIdRaw.split(',').map(s => s.trim()).filter(Boolean);
  const names = serverBrokerNameRaw.split(',').map(s => s.trim()).filter(Boolean);
  
  const brokerSelections = ids.map((id, i) => ({
    value: id,
    label: names[i] || id,
    name: names[i] || id,
    phone: '',
    raw: null
  }));
  
  if (brokerSelections.length === 0 && serverBrokerNameRaw) {
    brokerSelections.push({
      value: serverBrokerIdRaw || '',
      label: serverBrokerNameRaw,
      name: serverBrokerNameRaw,
      phone: '',
      raw: null
    });
  }
  
  setSelectedBrokers(brokerSelections);
  
  setBrokerOptions(prev => {
    const newOpts = [...prev];
    for (const sel of brokerSelections) {
      if (!newOpts.find(o => String(o.value) === String(sel.value))) {
        newOpts.unshift(sel);
      }
    }
    return newOpts;
  });
  
  setTimeout(() => loadBrokers(''), 100);
}
      
      // set visible names so inputs show them
      setDocSearch(res.data.ipd_dt.ipd_refer_doctor_name || "");
      setPkgSearch(res.data.ipd_dt.ipd_pkg_name || "");
      setWardSearch(res.data.ipd_dt.ipd_ward_name || "");
      setBedSearch(res.data.ipd_dt.ipd_bed_name || "");

      // Also set the visible label for the case input
      const caseId = ipd.ipd_case ?? ipd.case_id ?? ipd.cat_id ?? "";
      if (caseId) {
        const local = (formData.cases || []).find(c => String(c.cat_id) === String(caseId));
        if (local && local.cat_name) setCaseSearch(local.cat_name);
        else setCaseSearch(ipd.ipd_case_name ?? ipd.case_name ?? ipd.cat_name ?? "");
      }

      // ensure beds for the ward are loaded and bedSearch preserved
      await initData2ForWard(res.data.ipd_dt.ipd_ward, res.data.ipd_dt.ipd_bed, res.data.ipd_dt.ipd_id);
      if (res.data.ipd_dt.ipd_bed_name) {
        setBedSearch(res.data.ipd_dt.ipd_bed_name);
      } else {
        setTimeout(() => {
          setFormData(prev => {
            if (prev.ipd_bed && Array.isArray(prev.beds)) {
              const selectedBed = prev.beds.find(b => String(b.bed_id) === String(prev.ipd_bed));
              if (selectedBed && selectedBed.bed_name) {
                setBedSearch(selectedBed.bed_name);
              }
            }
            return prev;
          });
        }, 100);
      }
    } else {
      toast.error('Failed to load IPD for edit');
    }
  } catch (err) {
    console.error('Error loadIpdForEdit', err);
    toast.error('Error loading IPD for edit');
  }finally {
    // ADD THIS: Reset flag after a delay to let state settle
    setTimeout(() => setIsReloading(false), 300);
  }
};
// ========== REPLACE YOUR EXISTING TOTALS USEEFFECT WITH THIS ==========
// This version respects the patient type when calculating registration charges



// ==================== PASTE THIS useEffect (REPLACE YOUR EXISTING ONE) ====================

useEffect(() => {
  // Skip during reload to prevent race conditions
  if (isReloading) {
    return;
  }

  try {
    const type = (formData.ipd_type || '').toString();
    
    // Get original registration charge
    const regOriginalNum = Number.isFinite(parseFloat(formData.ipd_reg_charges_original)) 
      ? parseFloat(formData.ipd_reg_charges_original) 
      : 0;

    // Parse visible registration
    const parsedVisible = parseFloat(formData.ipd_reg_charges);
    const hasValidVisible = Number.isFinite(parsedVisible) && parsedVisible >= 0;

    // Parse discount
    const discountAmt = Number.isFinite(parseFloat(formData.ipd_discount)) 
      ? parseFloat(formData.ipd_discount) 
      : 0;

    // Package values
   // ✅ Use current package price (which user may have manually edited), 
// NOT the original price stored at selection time
const pkgPrice = Number.isFinite(parseFloat(formData.ipd_pkg_price)) 
? parseFloat(formData.ipd_pkg_price) 
: 0;
    const pkgDiscount = Number.isFinite(parseFloat(formData.ipd_pkg_discount)) 
      ? parseFloat(formData.ipd_pkg_discount) 
      : 0;
    
    // Get paid amount
    const paid = Number.isFinite(parseFloat(formData.ipd_paid)) 
      ? parseFloat(formData.ipd_paid) 
      : 0;

    // Determine visible registration based on type
    let regVisible;
    if (type === "Old") {
      regVisible = 0;
    } else {
      // ✅ KEY FIX: Only use visible if it's valid AND makes sense
      // If visible is 0 but original > 0 and no discount, use original
      if (hasValidVisible && parsedVisible > 0) {
        regVisible = parsedVisible;
      } else if (regOriginalNum > 0 && discountAmt === 0 && parsedVisible === 0) {
        // Visible is 0 but original exists and no discount - don't reset!
        // This prevents overwriting during initial load
        regVisible = regOriginalNum;
      } else if (hasValidVisible) {
        regVisible = parsedVisible;
      } else {
        regVisible = regOriginalNum;
      }
    }

    // Calculate subtotal
    const subtotal = Math.max(0, regVisible + pkgPrice - pkgDiscount);
    
    // Calculate due = subtotal - paid
    const due = Math.max(0, subtotal - paid);

    // Prepare updates
    const updates = {};
    const subtotalStr = Number(subtotal).toFixed(2);
    const dueStr = Number(due).toFixed(2);

    // Only update if values actually changed
    if (String(formData.ipd_total_price) !== subtotalStr) {
      updates.ipd_total_price = subtotalStr;
    }
    
    if (String(formData.ipd_due) !== dueStr) {
      updates.ipd_due = dueStr;
    }
    
    // Only update registration for "Old" type
    if (type === "Old" && parseFloat(formData.ipd_reg_charges) !== 0) {
      updates.ipd_reg_charges = "0.00";
    }
    
    // ✅ KEY FIX: If type is NOT "Old" and reg_charges is 0 but original > 0 and no discount,
    // restore the registration charge
    if (type !== "Old" && 
        parsedVisible === 0 && 
        regOriginalNum > 0 && 
        discountAmt === 0) {
      updates.ipd_reg_charges = Number(regOriginalNum).toFixed(2);
    }

    if (Object.keys(updates).length > 0) {
      console.log('Totals useEffect updating:', updates);
      setFormData(prev => ({ ...prev, ...updates }));
    }
  } catch (err) {
    console.warn("totals watcher error:", err);
  }
}, [
  formData.ipd_type,
  formData.ipd_reg_charges,
  formData.ipd_reg_charges_original,
  formData.ipd_pkg_original_price,
  formData.ipd_pkg_price,
  formData.ipd_pkg_discount,
  formData.ipd_discount,
  formData.ipd_total_price,
  formData.ipd_paid,
  formData.ipd_id,
  isReloading
]);

// ==================== PASTE THIS handleChange ipd_type SECTION ====================
// Find: else if (name === "ipd_type") {
// Replace the ENTIRE block with this:




//from here 

const handlePrint = async () => {
  const advanceFromDb = parseFloat(formData.ipd_advance_original);
  const totalpaiddb = parseFloat(formData.ipd_total_paid);
  const advanceFromUi = parseFloat(formData.ipd_advance);
  const advanceForPrint = (!isNaN(advanceFromDb) ? advanceFromDb : (!isNaN(advanceFromUi) ? advanceFromUi : 0));

  const isOldType = formData.ipd_type === "Old";
  
  // ✅ Use ORIGINAL registration charges (not the visible/discounted one)
  const regOriginal = isOldType 
    ? 0 
    : safeNum(formData.ipd_reg_charges_original || formData.ipd_reg_charges);
  
  // ✅ Package price (as user sees it)
  const pkgPrice = safeNum(formData.ipd_pkg_price);
  
  // ✅ Both discounts separately
  const regDiscount = safeNum(formData.ipd_discount);
  const pkgDiscount = safeNum(formData.ipd_pkg_discount);
  
  // ✅ Total discount = sum of registration discount + package discount
  const totalDiscount = regDiscount + pkgDiscount;
  
  const paid = safeNum(formData.ipd_paid);

  // ✅ Total = original registration + package price (BEFORE any discount)
  const totalAmount = regOriginal + pkgPrice;
  
  // ✅ Final = Total - Total Discount
  const finalAmount = Math.max(0, totalAmount - totalDiscount);
  
  // ✅ Due = Final - Paid
  const calculatedDue = Math.max(0, finalAmount - paid);
  
  console.log('PDF Print calculation:', {
    isOldType,
    regOriginal,
    pkgPrice,
    regDiscount,
    pkgDiscount,
    totalDiscount,
    totalAmount,
    finalAmount,
    paid,
    calculatedDue
  });

  const admissionData = {
    uhid: formData.ipd_uhid || "0001",
    patientRegNo: formData.ipd_display_no || formData.ipd_id || "00010",
    patientName: formData.ipd_patient_name || "",
    ageGender: `${formData.ipd_age || ""} / ${formData.ipd_patient_gender || ""}`,
    address: formData.ipd_address || "",
    city: formData.ipd_city,
    phone: formData.ipd_patient_mobile || "",
    ward: findNameById(formData.ipd_ward, formData.wards, "cat_id", "cat_name"),
    bed:
      formData.ipd_bed_name && formData.ipd_bed_name !== ""
        ? formData.ipd_bed_name
        : bedSearch && bedSearch !== ""
        ? bedSearch
        : findNameById(formData.ipd_bed, formData.beds, "bed_id", "bed_name"),
    guardian: formData.ipd_guardien_name || "",
    admissionDate: formData.ipd_reg_date || "",
    referredDoctor:
      formData.ipd_refer_doctor_name && formData.ipd_refer_doctor_name !== ""
        ? formData.ipd_refer_doctor_name
        : docSearch && docSearch !== ""
        ? docSearch
        : findNameById(formData.ipd_refer_doctor, formData.docs, "user_id", "fname"),
    department: findNameById(formData.ipd_specality, formData.cats, "cat_id", "cat_name"),

    // ✅ Show ORIGINAL registration in payment row
    payments: [
      ["1.", "Registration Fees", formData.ipd_pay_mode || "Cash", regOriginal]
    ],

    summary: {
      regCharges: regOriginal,        // ✅ Original (e.g., 100)
      pkgCharges: pkgPrice,           // ✅ Package as entered (e.g., 38000)
      total: totalAmount,             // ✅ Original total (38100)
      discount: totalDiscount,        // ✅ Sum of both discounts (100)
      advanced: Number(advanceForPrint),
      paid: paid,
      due: calculatedDue,             // ✅ Final - Paid (38000)
      final: finalAmount,             // ✅ Total - Discount (38000)
      totalp: totalpaiddb || 0
    },

    signatureName: ""
  };

  console.log("admissionData.summary:", admissionData.summary);

  generateAdmissionPdf(admissionData);
};

const fitText = (doc, text, maxWidth) => {
  if (!text) return "-";
  let t = String(text);
  while (doc.getTextWidth(t) > maxWidth && t.length > 0) {
    t = t.slice(0, -1);
  }
  return t;
};

const drawAdmissionHeaderAndPatientDetails = async (doc, data, headerLogo) => {
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 40;
  let y = 0;

  // ===== HEADER IMAGE =====
  const headerImageBase64 = await imageUrlToBase64(headerLogo);
  if (headerImageBase64) {
    doc.addImage(headerImageBase64, "PNG", 0, 0, pageWidth, 80);
  }

  y = 90;

  // ===== TITLE =====
  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.rect(margin, y, pageWidth - margin * 2, 25);
  doc.text(data.title, pageWidth / 2, y + 16, { align: "center" });
  y += 45;

  // ===== COLUMN SETUP =====
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");

  const labelW = 48;
  const valueW = 110;
  const gap = 15;

  const leftX  = margin;
  const midX   = leftX + labelW + valueW + gap;
  const rightX = midX  + labelW + valueW + gap;

  const lh = 14;

  const row = (l1, v1, l2, v2, l3, v3) => {
    doc.setFont("helvetica", "bold");
    doc.text(l1, leftX, y);
    doc.setFont("helvetica", "normal");
  doc.text(v1 || "-", leftX + 50, y);

  // MIDDLE
  doc.setFont("helvetica", "bold");
  doc.text(l2, midX, y);
  doc.setFont("helvetica", "normal");
  doc.text(v2 || "-", midX + 55, y);

  // RIGHT  ✅ FIXED HERE
  doc.setFont("helvetica", "bold");
  doc.text(l3, rightX, y);
  doc.setFont("helvetica", "normal");
  doc.text(v3 || "-", rightX + 90, y);

    
    

    y += lh;
  };

  // ===== ROWS =====
  row("UHID", data.uhid, "Patient", data.patientName, "Doctor", data.doctor);
  row("Age / Gen", data.ageGender, "Mobile", data.mobile, "Department  ", data.department);
  row("Ward", data.ward, "Bed", data.bed, "Admission", formatDateTime12h(data.admissionDate));
  row("Guardian", data.guardian, "Address", data.address, "", "");

  return y + 10;
};


const generateChecklistPdf = async (admissionData) => {
  const doc = new jsPDF("p", "pt", "a4");

  const startY = await drawAdmissionHeaderAndPatientDetails(doc, {
    title: "IPD CHECKLIST FORM",
    uhid: admissionData.uhid,
    patientName: admissionData.patientName,
    ageGender: admissionData.ageGender,
    mobile: admissionData.phone,
    doctor:
    formData.ipd_refer_doctor_name && formData.ipd_refer_doctor_name !== ""
      ? formData.ipd_refer_doctor_name
      : docSearch && docSearch !== ""
      ? docSearch
      : findNameById(formData.ipd_refer_doctor, formData.docs, "user_id", "fname"),
  department: findNameById(formData.ipd_specality, formData.cats, "cat_id", "cat_name"),
    ward: findNameById(formData.ipd_ward, formData.wards, "cat_id", "cat_name"),
    bed:
      formData.ipd_bed_name && formData.ipd_bed_name !== ""
        ? formData.ipd_bed_name
        : bedSearch && bedSearch !== ""
        ? bedSearch
        : findNameById(formData.ipd_bed, formData.beds, "bed_id", "bed_name"),
    guardian: admissionData.guardian,
    address: admissionData.address,
    admissionDate: formData.ipd_reg_date || ""
  }, headerLogo);

  autoTable(doc, {
    startY,
    head: [["Sl", "Checklist Items", "Yes", "No", "Remarks"]],
    body: [
      ["1", "Identification Band", "", "", ""],
      ["2", "Consent for admission and treatment taken", "", "", ""],
      [
        "3",
        `Patient and attendant made aware of patient bed No., Nursing Station, Telephone,
      bed controls, drinking water area, washroom, toilet.
      (In case of language barrier, the same is explained by the interpreter).
      Name and sign of interpreter: ______________________`,
        "",
        "",
        ""
      ],
      
      
      ["4", "Visiting policy and smoking policy conveyed to patient and attendant", "", "", ""],
      ["5", "Canteen service explained", "", "", ""],
      ["6", "Patient and attendant educated for fall prevention", "", "", ""],
      ["7", "Outside investigation reports present", "", "", ""],
      ["8", "Invasive devices (IV Canula / central line / foley's cath / ET Tube, etc) present from outside", "", "", ""],
      ["9", "Bedsore / pressure ulcer / would present from outside", "", "", ""],
      ["10", "Ornaments and valuable belonging handed over to patient party and get signed", "", "", ""],
    ],
    theme: "grid",
    headStyles: {
      fontStyle: "bold",
      fillColor: false,
      textColor: 0
    },
    styles: {
      fontSize: 10,
      lineWidth: 0.5
    }
  });

 // ===== AUTHORIZED SIGNATURE =====
const finalY = doc.lastAutoTable.finalY || startY + 200;

doc.setFont("helvetica", "normal");
doc.setFontSize(10);

// line
doc.line(
  doc.internal.pageSize.getWidth() - 200,
  finalY + 40,
  doc.internal.pageSize.getWidth() - 60,
  finalY + 40
);

// text
doc.text(
  "Authorized Signature",
  doc.internal.pageSize.getWidth() - 130,
  finalY + 55,
  { align: "center" }
);

window.open(doc.output("bloburl"), "_blank");

};



const generateVisitingPdf = async (admissionData) => {
  const doc = new jsPDF("p", "pt", "a4");

  const startY = await drawAdmissionHeaderAndPatientDetails(doc, {
    title: "IPD VISITING FORM",
    uhid: admissionData.uhid,
    patientName: admissionData.patientName,
    ageGender: admissionData.ageGender,
    mobile: admissionData.phone,
    doctor:
      formData.ipd_refer_doctor_name && formData.ipd_refer_doctor_name !== ""
        ? formData.ipd_refer_doctor_name
        : docSearch && docSearch !== ""
        ? docSearch
        : findNameById(formData.ipd_refer_doctor, formData.docs, "user_id", "fname"),
    department: findNameById(formData.ipd_specality, formData.cats, "cat_id", "cat_name"),
    ward: findNameById(formData.ipd_ward, formData.wards, "cat_id", "cat_name"),
    bed:
      formData.ipd_bed_name && formData.ipd_bed_name !== ""
        ? formData.ipd_bed_name
        : bedSearch && bedSearch !== ""
        ? bedSearch
        : findNameById(formData.ipd_bed, formData.beds, "bed_id", "bed_name"),
    guardian: admissionData.guardian,
    address: admissionData.address,
    admissionDate: formData.ipd_reg_date || ""
  }, headerLogo);

  // ===== VISITING DETAILS TABLE =====
  autoTable(doc, {
    startY,
    head: [["Date", "Time", "Doctor Name", "Notes"]],
    body: Array(8).fill(["", "", "", ""]),
    theme: "grid",
    headStyles: {
      fontStyle: "bold",
      fillColor: false,
      textColor: 0
    },
    styles: {
      fontSize: 10,
      lineWidth: 0.5
    }
  });

// ===== AUTHORIZED SIGNATURE =====
const finalY = doc.lastAutoTable.finalY || startY + 200;

doc.setFont("helvetica", "normal");
doc.setFontSize(10);

// line
doc.line(
  doc.internal.pageSize.getWidth() - 200,
  finalY + 40,
  doc.internal.pageSize.getWidth() - 60,
  finalY + 40
);

// text
doc.text(
  "Authorized Signature",
  doc.internal.pageSize.getWidth() - 130,
  finalY + 55,
  { align: "center" }
);

window.open(doc.output("bloburl"), "_blank");

};


const printThermalBarcodeIframe = async (patientName, age, uhid) => {
  // 1) Generate barcode data URL
  const barcodeData = generateBarcodeDataUrl(uhid, {
    width: 1.5,        // 👈 narrow bar (critical)
    height: 45,        // 👈 tall enough for scanner
    displayValue: false,
    margin: 0
  });
  

  // 2) build printable HTML
  const css = `
<style>
  @media print {
    @page {
      size: 40mm auto;
      margin: 0;
    }
    body {
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
  }

  body {
    margin: 0 !important;
    padding: 0 !important;
    width: 40mm;
    height: 25mm;
    position: relative;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 9px;
    color: #000;
  }

  .ticket {
  text-align: center;        /* 👈 NOT center */
  position: absolute;
  top: 4px;
  left: 2px;
}


  .meta {
    font-size: 9px;
    line-height: 1.1;
    margin: 1px 0;
  }

  .barcode {
    margin: 2px 0;
  }

  img.barimg {
    width: 100%;
    height: 45px;
    display: block;
  }

  .uhid {
    font-size: 9px;
    font-weight: bold;
    margin-top: 1px;
  }
</style>
`;



  const html = `<!doctype html><html><head><meta charset="utf-8"/><title>Print Barcode</title>${css}</head>
    <body>
      <div class="ticket">
       
        <div class="meta">Name: ${escapeHtml(patientName || 'N/A')}</div>
        <div class="meta">Age: ${escapeHtml(age || 'N/A')}</div>
        
        <div class="barcode">${ barcodeData ? `<img class="barimg" src="${barcodeData}" alt="${escapeHtml(uhid)}"/>` : '<div style="height:60px">Barcode error</div>' }</div>
        <div class="uhid">UHID: ${escapeHtml(uhid || 'N/A')}</div>
      </div>
    </body></html>`;

  // 3) create a hidden iframe (reuse if already present)
  const existing = document.getElementById('thermal-print-iframe');
  let iframe;
  if (existing) {
    iframe = existing;
    // clear previous content
    iframe.srcdoc = 'about:blank';
  } else {
    iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    iframe.id = 'thermal-print-iframe';
    document.body.appendChild(iframe);
  }

  // Write html into the iframe and wait for it to load
  return new Promise((resolve, reject) => {
    const onLoad = () => {
      try {
        const iwin = iframe.contentWindow;
        // wait for barcode image to load inside iframe (if present)
        const imgs = iframe.contentDocument.getElementsByTagName('img');
        if (imgs.length === 0) {
          // no image to wait for — print immediately
          iwin.focus();
          iwin.print();
          // optional: remove iframe after a short timeout to avoid interfering
          setTimeout(() => { /* keep iframe for reuse; remove if you prefer */ }, 500);
          resolve(true);
        } else {
          // wait for all images to load
          let loadedCount = 0;
          const checkDone = () => {
            loadedCount++;
            if (loadedCount >= imgs.length) {
              try {
                iwin.focus();
                iwin.print();
                resolve(true);
              } catch (err) {
                reject(err);
              }
            }
          };
          for (let img of imgs) {
            if (img.complete) checkDone();
            else img.addEventListener('load', checkDone);
            img.addEventListener('error', () => {
              // still attempt to print even if image fails
              checkDone();
            });
          }
        }
      } catch (err) {
        reject(err);
      }
    };

    // Use srcdoc if supported — it avoids navigation and is immediate
    if ('srcdoc' in iframe) {
      iframe.onload = onLoad;
      iframe.srcdoc = html;
    } else {
      // fallback for older browsers: write into document
      iframe.onload = onLoad;
      const doc = iframe.contentDocument || iframe.contentWindow.document;
      doc.open();
      doc.write(html);
      doc.close();
    }

    // safety: timeout rejects if printing fails to start in N seconds
    setTimeout(() => {
      // resolve anyway rather than leaving hanging; you can choose to reject
      resolve(false);
    }, 8000);
  }).catch(err => {
    console.error('Print iframe error', err);
    return false;
  });
};    


const generateAdmissionPdf = async (data) => {
    const doc = new jsPDF('p', 'pt', 'a4');
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 40;
    let y = 0; // To keep track of vertical position

    const headerImageBase64 = await imageUrlToBase64(headerLogo);

    // 1. === Header Image ===
    // Bro, you mentioned you already have this part.
    // Replace the placeholder rectangle with your doc.addImage logic.
     // ================= B. Header Logo Bar =================
    if (headerImageBase64) {
        doc.addImage(headerImageBase64, 'PNG', 0, 0, pageWidth, 80);
    }

    // ================= C. Invoice Heading Box =================

    y = 90; // Starting Y for the next section

    // 2. === Title: "ADMISSION RECORD" ===
    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.setDrawColor(0);
    doc.rect(margin, y, pageWidth - (margin * 2), 25);
    doc.text("IPD ADMISSION RECORD", pageWidth / 2, y + 16, { align: 'center' });
    y += 45;

    // 3. === Patient Details Section (Two Columns) ===
    doc.setFontSize(10);
    const leftColX = margin + 10;
    const rightColX = pageWidth / 2 + 80;
    const labelWidth = 90; // Width for the labels like "UHID No"

    // Helper to print a line in the details section
    const printDetailLine = (label, value, x, currentY) => {
        doc.setFont('helvetica', 'normal');
        doc.text(label, x, currentY);
        doc.text(":", x + labelWidth, currentY);
        doc.setFont('helvetica', 'normal');
        doc.text(String(value || ''), x + labelWidth + 10, currentY);
    };

    let detailsY = y;
    printDetailLine("UHID No", data.uhid, leftColX, detailsY);
    printDetailLine("IPD. No", data.patientRegNo, rightColX, detailsY);


    detailsY += 14;

    printDetailLine("Patient Name", data.patientName, leftColX, detailsY);
    printDetailLine("Age / Gender", data.ageGender, rightColX, detailsY);
    detailsY += 14;

    printDetailLine("Address", `${data.address || ''}${data.city ? ', ' + data.city : ''}`, leftColX, detailsY);
    printDetailLine("Phone No.", data.phone, rightColX, detailsY);
    detailsY += 14;

    printDetailLine("Ward", data.ward, leftColX, detailsY);
    printDetailLine("Bed", data.bed, rightColX, detailsY);
    detailsY += 14;

    printDetailLine("Guardian", data.guardian, leftColX, detailsY);
    printDetailLine("Admission Date", formatDateTime12h(data.admissionDate), rightColX, detailsY);
    detailsY += 14;
    
    printDetailLine("Referred Doctor", data.referredDoctor, leftColX, detailsY);
    printDetailLine("Department", data.department, rightColX, detailsY);
    
    y = detailsY + 25; // Update y for the next section

    // 4. === Payment History Table ===
//     autoTable(doc, {
//         startY: y,
//         head: [['Sl.No', 'Particular', 'Payment Method', 'Amount (Rs)']],
//         body: data.payments, // Pass the payment data here
//         theme: 'grid',
//         headStyles: {
//             fillColor: [255, 255, 255], // White header
//             textColor: 0,
//             fontStyle: 'bold',
//             lineWidth: 0.5,
//             lineColor: [0, 0, 0],
//         },
//         styles: {
//             fontSize: 10,
//             cellPadding: 5,
//             lineWidth: 0.5,
//             lineColor: [0, 0, 0]
//         },
//         columnStyles: {
//             0: { cellWidth: 50, halign: 'center' },
//             3: { halign: 'right' }
//         },
//         margin: { left: margin, right: margin }
//     });

    //let finalY = doc.lastAutoTable.finalY; // Y position after the table

//     // 5. === Summary Section ===
//     finalY += 25;
//     const summaryLabelColX = pageWidth - 220;
//     const summaryValueColX = pageWidth - margin;

//     const printSummaryLine = (label, value) => {
//         doc.setFontSize(10);
//         doc.setFont('helvetica', 'normal');
//         doc.text(label, summaryLabelColX, finalY, { align: 'left' });
//         doc.text(':', summaryLabelColX + 100, finalY);
//         doc.setFont('helvetica', 'bold');
//         doc.text('Rs.', summaryValueColX - 60, finalY, { align: 'left' });
//         doc.text(value.toFixed(2), summaryValueColX, finalY, { align: 'right' });
//         finalY += 15;
//     };
    
//     printSummaryLine("Registration Charges", data.summary.regCharges);
//     printSummaryLine("Package Charges", data.summary.pkgCharges);
//     printSummaryLine("Total Amount", data.summary.total);
//     printSummaryLine("Discount Amount", data.summary.discount);
//     printSummaryLine("Final Amount", data.summary.final);
//     printSummaryLine("Due Amount", data.summary.due);
//     printSummaryLine("Advanced Amount", data.summary.advanced);
//     printSummaryLine("Total Amount Paid", data.summary.totalp);
//   const advanced = parseInt(data.summary.advanced) || 0;
// const final = parseInt(data.summary.final) || 0;

// const remainingAdvanced = Number.isFinite(Number(data.summary.advanced))
//   ? parseFloat(data.summary.advanced)
//   : 0;




    
// const signatureLineY = finalY - 25; // "Remaining Advanced" wali line ka Y

// // Left side pe laane ke liye
// const signatureX = margin; 

// doc.setFontSize(10);
// doc.setFont('helvetica', 'normal');

// // Signature Name
// doc.text(data.signatureName, signatureX, signatureLineY - 5, { align: 'left' });

// // Signature Line
// doc.line(signatureX, signatureLineY, signatureX + 150, signatureLineY);

// // Label
// doc.text("Authorized Signature", signatureX, signatureLineY + 15, { align: 'left' });



    // 7. === Open the PDF ===
    const pdfBlobUrl = doc.output('bloburl');
    window.open(pdfBlobUrl, '_blank');
};

const generateInvestigationPdf = async (admissionData) => {
  const doc = new jsPDF("p", "pt", "a4");
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const margin = 40;
  const outlinePad = 5;
  const outlineLeft = margin - outlinePad;
  const outlineRight = pageWidth - margin + outlinePad;
  const outlineWidth = outlineRight - outlineLeft;
  const innerLeft = margin + 10;
  const innerRight = pageWidth - margin - 10;

  // ===== HEADER IMAGE =====
  const headerImageBase64 = await imageUrlToBase64(headerLogo);
  if (headerImageBase64) {
    doc.addImage(headerImageBase64, "PNG", 0, 0, pageWidth, 80);
  }

  // ===== OUTLINE starts here =====
  const outlineTop = 88;

  let y = 90;

  // ===== TITLE BOX =====
  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.setDrawColor(0);
  doc.setLineWidth(0.5);
  doc.rect(margin, y, pageWidth - margin * 2, 25);
  doc.text("PATIENT FORM", pageWidth / 2, y + 16, { align: "center" });
  y += 45;

  // ===== PATIENT DETAILS (compact layout to avoid overflow) =====
  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");

  const lh = 14;
  const col1X = margin + 10;
  const col1ValX = col1X + 55;
  const col2X = 220;
  const col2ValX = col2X + 55;
  const col3X = 390;
  const col3ValX = col3X + 65;

  const maxValWidth = 120; // max width for value text to prevent overflow

  const detailRow = (l1, v1, l2, v2, l3, v3) => {
    // ✅ FIX: Ensure all values are strings to prevent jsPDF.text crash
    l1 = String(l1 ?? ''); v1 = String(v1 ?? '');
    l2 = String(l2 ?? ''); v2 = String(v2 ?? '');
    l3 = String(l3 ?? ''); v3 = String(v3 ?? '');

    doc.setFont("helvetica", "bold");
    doc.text(l1, col1X, y);
    doc.setFont("helvetica", "normal");
    doc.text(fitText(doc, v1 || "-", maxValWidth), col1ValX, y);

    doc.setFont("helvetica", "bold");
    doc.text(l2, col2X, y);
    doc.setFont("helvetica", "normal");
    doc.text(fitText(doc, v2 || "-", maxValWidth), col2ValX, y);

    doc.setFont("helvetica", "bold");
    doc.text(l3, col3X, y);
    doc.setFont("helvetica", "normal");
    const rightMaxW = outlineRight - col3ValX - 10;
    doc.text(fitText(doc, v3 || "-", rightMaxW), col3ValX, y);

    y += lh;
  };

  const doctorName = formData.ipd_refer_doctor_name && formData.ipd_refer_doctor_name !== ""
    ? formData.ipd_refer_doctor_name
    : docSearch && docSearch !== ""
    ? docSearch
    : findNameById(formData.ipd_refer_doctor, formData.docs, "user_id", "fname");

  const deptName = findNameById(formData.ipd_specality, formData.cats, "cat_id", "cat_name");
  const wardName = findNameById(formData.ipd_ward, formData.wards, "cat_id", "cat_name");
  const bedName = formData.ipd_bed_name && formData.ipd_bed_name !== ""
    ? formData.ipd_bed_name
    : bedSearch && bedSearch !== ""
    ? bedSearch
    : findNameById(formData.ipd_bed, formData.beds, "bed_id", "bed_name");

  detailRow("UHID", admissionData.uhid, "Patient", admissionData.patientName, "Doctor", doctorName);
  detailRow("Age / Gen", admissionData.ageGender, "Mobile", admissionData.phone, "Dept.", deptName);
  detailRow("Ward", wardName, "Bed", bedName, "Admission", formatDateTime12h(formData.ipd_reg_date || ""));
  detailRow(
    "Guardian", 
    admissionData.guardian || '', 
    "Address", 
    `${admissionData.address || ''}${formData.ipd_city ? ', ' + formData.ipd_city : ''}`,
    "", 
    ""
  );

  y += 5;

  // ===== HORIZONTAL LINE after patient details =====
  doc.setDrawColor(0);
  doc.setLineWidth(0.8);
  doc.line(outlineLeft, y, outlineRight, y);

  y += 15;

  // ===== SECTION DRAWING HELPER =====
  const drawSection = (label, lineCount) => {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.setDrawColor(0);
    doc.text(label, innerLeft, y);
    y += 6;

    // Underline heading
    doc.setLineWidth(0.6);
    doc.line(innerLeft, y, innerLeft + doc.getTextWidth(label), y);
    y += 16;

    // Ruled lines
    doc.setLineWidth(0.3);
    doc.setDrawColor(180, 180, 180);
    for (let i = 0; i < lineCount; i++) {
      doc.line(innerLeft, y, innerRight, y);
      y += 20;
    }

    y += 14;
  };

  // ===== SECTIONS =====
  drawSection("Brief Clinical Note:", 3);
  drawSection("Clinical Diagnosis:", 3);
  drawSection("Investigation:", 4);
  drawSection("Treatment:", 7);

  // ===== AUTHORIZED SIGNATURE =====
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setDrawColor(0);
  doc.setLineWidth(0.5);

  doc.line(pageWidth - 200, y + 20, pageWidth - 60, y + 20);
  doc.text("Authorized Signature", pageWidth - 130, y + 35, { align: "center" });

  // ===== FULL PAGE OUTLINE =====
  const outlineBottom = pageHeight - 15;
  doc.setDrawColor(0);
  doc.setLineWidth(1);
  doc.rect(outlineLeft, outlineTop, outlineWidth, outlineBottom - outlineTop);

  window.open(doc.output("bloburl"), "_blank");
};
// FIXED useEffect for totals calculation
// Replace BOTH of your totals calculation useEffect blocks with this ONE




// from here end








// fetch config/logo
const fetchConfigData = async () => {
    try {
        const res = await axios.post(
            `${AppConst.BASE_URL + AppConst.getconfig}?config_type=lab`
        );
        if (res.data.status) {
          console.log(res.data)
            const data = res.data;
            setHeaderLogo( data.header_logo);
        }
    } catch (err) {
        console.error("Error fetching config:", err);
    }
};

useEffect(() => {
    fetchConfigData();
}, []); // once

// keep your PDF code unchanged (copied from your original)
const imageUrlToBase64 = async (url) => {
    if (!url) return null;
    try {
        const response = await fetch(url);
        if (!response.ok) return null;
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    } catch (error) {
        console.error("Error converting image to Base64:", error);
        return null;
    }
};
const findNameById = (id, array, idField, nameField) => {
    if (!id || !Array.isArray(array)) return '';
    const item = array.find(i => i[idField] == id);
    return item ? item[nameField] : '';
};



   function calculateFinalPrice(totalPrice, discountAmount) {
  const total = parseFloat(totalPrice) || 0;
  const discount = parseFloat(discountAmount) || 0;
  const finalPrice = Math.max(0, total - discount);
  return Number(finalPrice).toFixed(2);
}



function formatMoney(value, decimals = 2) {
  // Accept numbers or numeric strings; return a formatted string with exactly decimals digits
  const n = Number(value);
  if (Number.isFinite(n)) return n.toFixed(decimals);
  // fallback: try parseFloat after stripping non-numeric chars
  const cleaned = String(value || '').replace(/[^0-9.-]+/g, '');
  const p = parseFloat(cleaned);
  if (Number.isFinite(p)) return p.toFixed(decimals);
  // ultimate fallback
  return (0).toFixed(decimals);
}

// Example usage inside PDF printing:
function printSummaryLine(doc, label, value, x, y) {
  const txt = formatMoney(value, 2);
  doc.text(`${label}: ₹${txt}`, x, y);
}

const safeNum = (v) => {
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : 0;
};






const handleSelIpdUser = async (user) => {
  if (!user) return;

  try {
    const fd = new FormData();
    fd.append("lab_reg_uhid", user.lab_reg_uhid);

    const response = await axios.post(
      AppConst.BASE_URL + AppConst.searchUhidUrlCall,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    if (response.data.status && response.data.records.length > 0) {
      const details = response.data.records[0];

      // ✅ NEW REGISTRATION on same UHID - clear ipd_id, keep only patient details
      setFormData(prev => ({
        ...prev,
        ipd_id: "",  // ← EMPTY = new registration
        ipd_type: "Old",
        ipd_uhid: (details.lab_reg_uhid || "").trim(),  // ← Same UHID
        ipd_patient_name: details.lab_reg_name || "",
        ipd_patient_gender: details.lab_reg_gender || "",
        ipd_patient_mobile: details.lab_reg_mobile || "",
        ipd_address: details.lab_reg_address || "",
        ipd_city: details.lab_reg_city || "",
        ipd_age_year: details.lab_reg_age_year || "",
        ipd_guardien_name: details.lab_guardian_name || "",
        // ✅ Reset financial fields for new registration
        ipd_advance: 0,
        ipd_paid: 0,
        ipd_due: 0,
        ipd_reg_charges: "",
        ipd_discount: 0,
        // ✅ Reset date to today (new registration)
        ipd_reg_date: new Date().toISOString().split('T')[0],
      }));

      toast.success("Patient found. Creating new IPD registration.");
    }

    setUhidSuggestions([]);
    setIpdSearchInput(''); 
  } catch (err) {
    console.error("Error:", err);
    toast.error("Failed to fetch patient data.");
  }
};
  
const runIpdPatientSearch = async (params) => {
  setIpdSearchLoading(true);
  try {
      const fd = new FormData();
      Object.entries(params).forEach(([k, v]) => fd.append(k, v));
      const response = await axios.post(
          AppConst.BASE_URL + AppConst.searchUhidUrlCall, fd,
          { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      if (!response.data.status) { toast.error('No patient found'); return; }
      let records = response.data.records || [];

      // filter by current ipd_type
      if (formData.ipd_type === 'OPD') {
          records = records.filter(r => r.lab_reg_type === 'OPD');
      } else if (['IPD','New Visit','Old'].includes(formData.ipd_type)) {
          records = records.filter(r => r.lab_reg_type === 'IPD');
      }

      if (records.length === 0) { toast.error('No patient found'); return; }
      if (records.length === 1) {
          applyIpdPatient(records[0]);
      } else {
          setIpdPatientResults(records);
          setShowIpdPatientModal(true);
      }
  } catch (err) {
      console.error('IPD search error:', err);
      toast.error('Error searching patient');
  } finally {
      setIpdSearchLoading(false);
  }
};

// ✅ Smart unified search — auto-detects UHID / Phone / Name
const handleIpdUnifiedSearch = (val) => {
  setIpdSearchInput(val);
  const trimmed = val.trim();

  if (ipdSearchDebounceRef.current) clearTimeout(ipdSearchDebounceRef.current);

  // Empty → clear suggestions
  if (trimmed.length === 0) {
    setUhidSuggestions([]);
    return;
  }

  // Detect input type
  const isPhone        = /^[6-9]\d{9}$/.test(trimmed);          // 10-digit mobile
  const isPartialPhone = /^\d+$/.test(trimmed);                 // pure digits
  const isUhidLike     = /^[A-Za-z]{1,3}\d+/.test(trimmed);     // e.g. SH00028123

  // Phone complete → immediate search (popup if multiple matches)
  if (isPhone) {
    ipdSearchDebounceRef.current = setTimeout(() => {
      runIpdPatientSearch({ lab_reg_mobile: trimmed });
      setUhidSuggestions([]);
    }, 300);
    return;
  }

  // Partial phone — wait
  if (isPartialPhone && trimmed.length < 10) {
    setUhidSuggestions([]);
    return;
  }

  // UHID or name → live suggestions (debounced)
  if (trimmed.length >= 3) {
    ipdSearchDebounceRef.current = setTimeout(async () => {
      setIpdSearchLoading(true);
      try {
        const fd = new FormData();
        if (isUhidLike) {
          fd.append('lab_reg_uhid', trimmed);
        } else {
          fd.append('lab_reg_name', trimmed);
        }
        const response = await axios.post(
          AppConst.BASE_URL + AppConst.searchUhidUrlCall,
          fd,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        if (response.data.status) {
          let records = response.data.records || [];
          // Apply same type filter as before
          if (formData.ipd_type === 'OPD') {
            records = records.filter(r => r.lab_reg_type === 'OPD');
          } else if (['IPD', 'New Visit', 'Old'].includes(formData.ipd_type)) {
            records = records.filter(r => r.lab_reg_type === 'IPD');
          }
          setUhidSuggestions(records);
        } else {
          setUhidSuggestions([]);
        }
      } catch (err) {
        console.error('IPD search error:', err);
        setUhidSuggestions([]);
      } finally {
        setIpdSearchLoading(false);
      }
    }, 400);
  } else {
    setUhidSuggestions([]);
  }
};

const applyIpdPatient = (user) => {
  setFormData(prev => ({
      ...prev,
      ipd_id:             '',
      ipd_type:           'Old',
      ipd_uhid:           (user.lab_reg_uhid || '').trim(),
      ipd_patient_name:   user.lab_reg_name    || '',
      ipd_patient_gender: user.lab_reg_gender  || '',
      ipd_patient_mobile: user.lab_reg_mobile  || '',
      ipd_address:        user.lab_reg_address || '',
      ipd_city:           user.lab_reg_city    || '',
      ipd_age_year:       user.lab_reg_age_year || '',
      ipd_guardien_name:  user.lab_guardian_name || '',
      ipd_advance: 0, ipd_paid: 0, ipd_due: 0,
      ipd_reg_charges: '', ipd_discount: 0,
      ipd_reg_date: new Date().toISOString().split('T')[0],
  }));
  setShowIpdPatientModal(false);
  setIpdSearchInput('');      
  setUhidSuggestions([]);      
  toast.success('Patient details loaded');
};


  const calculateDue = (data) => {
    // Get visible registration (already discounted) or fall back to original
    const regVisible = parseFloat(data.ipd_reg_charges);
    const regOriginal = parseFloat(data.ipd_reg_charges_original) || 0;
    
    // Use visible if it's a valid number (including 0), otherwise use original
    const regToUse = (!isNaN(regVisible) && isFinite(regVisible)) ? regVisible : regOriginal;
    
    // Package calculations
    const pkgOriginal = parseFloat(data.ipd_pkg_original_price) || parseFloat(data.ipd_pkg_price) || 0;
    const pkgDiscountAmount = parseFloat(data.ipd_pkg_discount) || 0;
    
    // Base amount = visible registration + package - package discount
    // Note: ipd_discount is already applied to ipd_reg_charges, so we don't subtract it again
    const dueBase = Math.max(0, regToUse + pkgOriginal - pkgDiscountAmount);
    
    // Subtract paid amount (advance is stored separately)
    const paid = parseFloat(data.ipd_paid) || 0;
    
    let due = dueBase - paid;
    return due >= 0 ? due.toFixed(2) : "0.00";
};


  


// ---------- NEW: watchers to set visible names when lists arrive ----------
useEffect(() => {
  if (formData.ipd_refer_doctor && Array.isArray(formData.docs)) {
    const sel = formData.docs.find(d => String(d.user_id) === String(formData.ipd_refer_doctor));
    if (sel) setDocSearch(sel.fname || "");
  }
}, [formData.docs, formData.ipd_refer_doctor]);

useEffect(() => {
  if (formData.ipd_pkg && Array.isArray(formData.pkgs)) {
    const sel = formData.pkgs.find(p => String(p.cat_id) === String(formData.ipd_pkg));
    if (sel) setPkgSearch(sel.cat_name || "");
  }
}, [formData.pkgs, formData.ipd_pkg]);



useEffect(() => {
  const handleOutside = (e) => {
      const input = document.getElementById('ipd_uhid_input');
      if (input && !input.parentElement?.contains(e.target)) {
          setUhidSuggestions([]);
      }
  };
  document.addEventListener('mousedown', handleOutside);
  return () => document.removeEventListener('mousedown', handleOutside);
}, []);


useEffect(() => {
  if (formData.ipd_ward && Array.isArray(formData.wards)) {
    const s = formData.wards.find(w => String(w.cat_id) === String(formData.ipd_ward));
    if (s) setWardSearch(s.cat_name || "");
  }
}, [formData.wards, formData.ipd_ward]);

useEffect(() => {
  if (formData.ipd_bed && Array.isArray(formData.beds)) {
    const s = formData.beds.find(b => String(b.bed_id) === String(formData.ipd_bed));
    if (s) {
      setBedSearch(s.bed_name || "");
      setFormData(prev => ({ ...prev, ipd_bed_price: s.bed_price || prev.ipd_bed_price }));
    }
  }
}, [formData.beds, formData.ipd_bed]);




// ---------- mount useEffect: loads initial data and calls loadIpdForEdit if session has ipd_dt ----------
// inside OpdRegistrations component, replace your existing mount useEffect with this
useEffect(() => {
    const run = async () => {
      // set today's default reg date (keep your existing behavior)
      const now = new Date();
const pad = n => String(n).padStart(2, '0');
const formatted = `${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())}T${pad(now.getHours())}:${pad(now.getMinutes())}`;
setFormData(prev => ({ ...prev, ipd_reg_date: formatted }));
      //console.log('Component mounted');
  
      // load ldata + initial lists
      const storedData = sessionStorage.getItem("ldata");
      if (storedData) {
        setLdata(JSON.parse(storedData));
      }
  
      // await initData so lists (docs, wards, pkgs etc.) are available before we patch form
      try {
        if (typeof initData === 'function') {
          await initData();
        }
      } catch (err) {
        console.warn('initData failed (continuing):', err);
      }
  
      // fetch other helpers
      try { await fetchCaseList(); } catch (e) { console.warn('fetchCaseList failed', e); }
      try { await initData1(); } catch (e) { console.warn('initData1 failed', e); }
      try { await initData2(); } catch (e) { console.warn('initData2 failed', e); }
      await fetchInsuranceOptions();
      await fetchTpaOptions();
      // fetch config/logo
      fetchConfigData();
  
      // ---- check sessionStorage for edit payload ----
      const sess = sessionStorage.getItem('ipd_dt');
      if (!sess) return;
  
      let parsed;
      try {
        parsed = JSON.parse(sess);
      } catch (e) {
        console.warn('ipd_dt is not valid JSON:', e, sess);
        sessionStorage.removeItem('ipd_dt');
        return;
      }
  
      // If session object contains only ipd_id -> call your API loader
      if (parsed && (parsed.ipd_id || parsed.ipdId || parsed.id)) {
        const ipdId = parsed.ipd_id || parsed.ipdId || parsed.id;
        await loadIpdForEdit(ipdId);
        sessionStorage.removeItem('ipd_dt');
        return;
      }
  
      // If parsed looks like a full row, map fields into formData (robust mapping)
      if (parsed && typeof parsed === 'object') {
        setOriginalRecord(parsed);
        const map = (val) => val === undefined ? '' : val;

        // normalize reg date to YYYY-MM-DD for input field
        let regDate = map(parsed.ipd_reg_date || parsed.reg_date || parsed.ipd_datetime || '');
        try {
          if (regDate) {
            const d = new Date(regDate);
            if (!isNaN(d)) regDate = d.toISOString().split('T')[0];
          }
        } catch (e) { /* ignore */ }
  
        // apply values to formData
        setFormData(prev => ({
          ...prev,
          ipd_id: map(parsed.ipd_id || parsed.id),
          ipd_display_no: map(parsed.ipd_display_no),
          ipd_uhid: map(parsed.ipd_uhid || parsed.uhid),
          ipd_patient_title: map(parsed.ipd_patient_title || prev.ipd_patient_title),
          ipd_patient_name: map(parsed.ipd_patient_name || parsed.patient_name || prev.ipd_patient_name),
          ipd_patient_gender: map(parsed.ipd_patient_gender || prev.ipd_patient_gender),
          ipd_patient_mobile: map(parsed.ipd_patient_mobile || parsed.ipd_cont_number || prev.ipd_patient_mobile),
          ipd_guardien_name: map(parsed.ipd_guardien_name || parsed.guardian_name || prev.ipd_guardien_name),
          ipd_address: map(parsed.ipd_address || parsed.address || prev.ipd_address),
          ipd_city: map(parsed.ipd_city || prev.ipd_city),
          ipd_age: map(parsed.ipd_age || prev.ipd_age),
          ipd_type: map(parsed.ipd_type || prev.ipd_type),
          ipd_specality: map(parsed.ipd_specality || parsed.ipd_speciality || prev.ipd_specality),
          ipd_refer_doctor: map(parsed.ipd_refer_doctor || parsed.refer_doctor || prev.ipd_refer_doctor),
          ipd_file_number: map(parsed.ipd_file_number || prev.ipd_file_number),
          ipd_reg_date: regDate || prev.ipd_reg_date,
          ipd_ward: map(parsed.ipd_ward || parsed.ward || prev.ipd_ward),
          ipd_bed: map(parsed.ipd_bed || parsed.bed || prev.ipd_bed),
          ipd_bed_price: map(parsed.ipd_bed_price || parsed.bed_price || prev.ipd_bed_price),
          ipd_pkg: map(parsed.ipd_pkg || parsed.pkg || prev.ipd_pkg),
          ipd_pkg_price: map(parsed.ipd_pkg_price || parsed.pkg_price || prev.ipd_pkg_price),
          ipd_pkg_discount: map(parsed.ipd_pkg_discount || prev.ipd_pkg_discount),
          ipd_total_price: map(parsed.ipd_total_price || prev.ipd_total_price),
          ipd_discount: map(parsed.ipd_discount || prev.ipd_discount),
          ipd_reg_charges: map(parsed.ipd_reg_charges || prev.ipd_reg_charges),
          // GOOD: prefer parsed.ipd_reg_charges_original, fallback to parsed.ipd_reg_charges
          ipd_reg_charges_original: map(parsed.ipd_reg_charges_original ?? parsed.ipd_reg_charges ?? prev.ipd_reg_charges_original),

          ipd_advance: map(parsed.ipd_advance || prev.ipd_advance),
          ipd_advance_original: map(parsed.ipd_advance || prev.ipd_advance_original),
         // ensure canonical field name ipd_total_paid exists on formData
ipd_total_paid: map(parsed.ipd_total_paid ?? parsed.total_paid ?? prev.ipd_total_paid ?? ""),

          ipd_paid: map(parsed.ipd_paid || prev.ipd_paid),
          ipd_due: map(parsed.ipd_due || prev.ipd_due),
          ipd_pay_mode: map(parsed.ipd_pay_mode || prev.ipd_pay_mode),
          ipd_remarks: map(parsed.ipd_remarks || prev.ipd_remarks),
        }));
  // Inside the mount useEffect where you set formData from session:
  const sessIdRaw = String(parsed.ipd_broker_id ?? parsed.brokerId ?? '');
  const sessNameRaw = String(parsed.ipd_broker_name ?? parsed.broker_name ?? parsed.brokerName ?? '');
  if (sessIdRaw || sessNameRaw) {
    const ids = sessIdRaw.split(',').map(s => s.trim()).filter(Boolean);
    const names = sessNameRaw.split(',').map(s => s.trim()).filter(Boolean);
    const sels = ids.map((id, i) => ({
      value: id, label: names[i] || id, name: names[i] || id, phone: '', raw: null
    }));
    if (sels.length === 0 && sessNameRaw) {
      sels.push({ value: sessIdRaw, label: sessNameRaw, name: sessNameRaw, phone: '', raw: null });
    }
    setSelectedBrokers(sels);
  }
  setTimeout(() => loadBrokers(''), 100);
        // set visible labels (if available)
        if (parsed.ipd_refer_doctor_name) setDocSearch(parsed.ipd_refer_doctor_name);
        if (parsed.ipd_pkg_name) setPkgSearch(parsed.ipd_pkg_name);
        if (parsed.ipd_ward_name) setWardSearch(parsed.ipd_ward_name);
        if (parsed.ipd_bed_name) setBedSearch(parsed.ipd_bed_name);
  
        // try to ensure beds for ward are loaded and bed price set
        if (parsed.ipd_ward) {
          await initData2ForWard(parsed.ipd_ward, parsed.ipd_bed);
        }
  
        sessionStorage.removeItem('ipd_dt');
      }
    };
  
    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
   // eslint-disable-line react-hooks/exhaustive-deps
  // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-xxl-12">
                       
                            <div class="card">
                                <div class="card-body">
                                    <h2 style={{ color: "#405189" }}>IPD Registration</h2>
                                    
                                    <div class="live-preview">
                                        <form onSubmit={handleSubmit}>
                                            <div class="row">

                                                <div class="col-md-12">
                                                    <br /><br />
                                                </div>
                                               {/* ── ROW 1: IPD Type + Search (same row when Old/OPD) ── */}
<div className="col-md-12">
    <div className="row align-items-end mb-3">

        {/* IPD Type */}
        <div className="col-md-2">
            <label className="form-label">IPD Type</label>
            {formData.ipd_remarks === "Moved from OPD" ? (
                <input type="text" className="form-control"
                    value={formData.ipd_type} readOnly
                    style={{ backgroundColor: "#eee" }}/>
            ) : (
                <select className="form-control" name="ipd_type"
                    onChange={handleChange} value={formData.ipd_type}>
                    <option value="New Visit">New Visit</option>
                    <option value="Old">Old</option>
                    <option value="OPD">OPD</option>
                </select>
            )}
        </div>

        {(formData.ipd_type === 'Old' || formData.ipd_type === 'OPD') && (
    <div className="col-md-6">
        <label className="form-label">
            Search Patient
            <small className="text-muted ms-2" style={{fontSize:11, fontWeight:400}}>
                (UHID / Phone / Name)
            </small>
        </label>

        <div style={{position:'relative'}}>
            <div className="input-group">
                <span className="input-group-text" style={{background:'#f8f9fa'}}>
                    <i className="ri-search-line text-primary"/>
                </span>
                <input
                    type="text"
                    className="form-control"
                    placeholder="Type UHID, 10-digit phone, or patient name..."
                    value={ipdSearchInput}
                    onChange={e => handleIpdUnifiedSearch(e.target.value)}
                    autoComplete="off"
                    disabled={formData.ipd_remarks === 'Moved from OPD'}
                    style={{
                        backgroundColor: formData.ipd_remarks === 'Moved from OPD' ? '#eee' : 'white'
                    }}
                />
                {ipdSearchLoading && (
                    <span className="input-group-text" style={{background:'#fff'}}>
                        <span className="spinner-border spinner-border-sm text-primary"/>
                    </span>
                )}
                {ipdSearchInput && formData.ipd_remarks !== 'Moved from OPD' && (
                    <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => { setIpdSearchInput(''); setUhidSuggestions([]); }}
                        title="Clear">
                        <i className="ri-close-line"/>
                    </button>
                )}
            </div>

            <small className="text-muted" style={{fontSize:10}}>
                💡 Phone (10 digits) searches instantly. UHID/Name needs 3+ characters.
            </small>

            {/* Unified suggestions dropdown */}
            {uhidSuggestions.length > 0 && (
                <ul style={{
                    position:'absolute',
                    top:'100%',
                    left:0,
                    right:0,
                    zIndex:1050,
                    maxHeight:280,
                    overflowY:'auto',
                    border:'1px solid #dee2e6',
                    borderRadius:4,
                    boxShadow:'0 4px 12px rgba(0,0,0,0.15)',
                    margin:'4px 0 0 0',
                    padding:0,
                    listStyle:'none',
                    background:'#fff'
                }}>
                    <li style={{
                        padding:'6px 12px',
                        background:'#f8f9fa',
                        borderBottom:'1px solid #dee2e6',
                        fontSize:11,
                        color:'#405189',
                        fontWeight:600
                    }}>
                        {uhidSuggestions.length} match{uhidSuggestions.length !== 1 ? 'es' : ''} found — click to select
                    </li>
                    {uhidSuggestions.map((user, idx) => (
                        <li key={idx}
                            onClick={() => { handleSelIpdUser(user); }}
                            style={{
                                cursor:'pointer',
                                fontSize:12,
                                padding:'10px 12px',
                                borderBottom:'1px solid #f0f0f0',
                                transition:'background .1s'
                            }}
                            onMouseEnter={e => e.currentTarget.style.background='#f0f4ff'}
                            onMouseLeave={e => e.currentTarget.style.background='#fff'}>
                            <div className="d-flex justify-content-between align-items-start">
                                <div style={{flex:1}}>
                                    <div>
                                        <strong style={{color:'#405189'}}>
                                            {user.lab_reg_name_title} {user.lab_reg_name}
                                        </strong>
                                    </div>
                                    <div className="text-muted mt-1" style={{fontSize:11}}>
                                        <span className="me-2">
                                            <i className="ri-fingerprint-line me-1"/>
                                            <strong>{user.lab_reg_uhid}</strong>
                                        </span>
                                        <span className="me-2">
                                            <i className="ri-phone-line me-1"/>
                                            {user.lab_reg_mobile}
                                        </span>
                                        <span className="me-2">
                                            {user.lab_reg_age_year ? user.lab_reg_age_year+'Y' : ''} / {user.lab_reg_gender}
                                        </span>
                                    </div>
                                </div>
                                <div className="d-flex gap-1 ms-2 flex-shrink-0 flex-wrap" style={{maxWidth:120}}>
                                    {(user.lab_visit_count > 0) && (
                                        <span className="badge" style={{background:'#cff4fc',color:'#055160',fontSize:9}}>
                                            🧪{user.lab_visit_count}x
                                        </span>
                                    )}
                                    {(user.ipd_visit_count > 0) && (
                                        <span className="badge" style={{background:'#cfe2ff',color:'#084298',fontSize:9}}>
                                            🏥{user.ipd_visit_count}x
                                        </span>
                                    )}
                                    {(user.opd_visit_count > 0) && (
                                        <span className="badge" style={{background:'#d1e7dd',color:'#0f5132',fontSize:9}}>
                                            🩺{user.opd_visit_count}x
                                        </span>
                                    )}
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    </div>
)}

    </div>
</div>
                                                




                                                <div class="col-md-4">
                                                    <div >
                                                        <label for="productname-field" class="form-label">Patient Name</label>
                                                        <div class="row">
                                                            <div class="col-md-4">
                                                                <select class="form-control" data-trigger="" name="ipd_patient_title" onChange={handleChange} value={formData.ipd_patient_title}>
                                                                    <option value="Mr.">Mr.</option>
                                                                    <option value="Mrs.">Mrs.</option>
                                                                    <option value="Miss">Miss</option>
                                                                    <option value="Master">Master</option>
                                                                    <option value="Baby">Baby</option>
                                                                    <option value="Others">Others</option>
                                                                </select>
                                                            </div>
                                                            <div class="col-md-8">
                                                                <input type="text" class="form-control" placeholder="Enter Name" name="ipd_patient_name" onChange={handleChange} value={formData.ipd_patient_name} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div >
                                                        <label for="productname-field" class="form-label">Gender</label>
                                                        <select class="form-control" data-trigger="" name="ipd_patient_gender" onChange={handleChange} value={formData.ipd_patient_gender} style={{background: "#eeeeee"}}>
                                                            <option value="Male">Male</option>
                                                            <option value="Female">Female</option>
                                                            <option value="Other">Other</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div class="col-md-4">
                                                <div className="mb-3">
  <label htmlFor="firstNameinput" className="form-label">Mobile Number</label>
  <input
    type="text"
    className="form-control"
    placeholder="Enter Mobile Number"
    name="ipd_patient_mobile"
    onChange={handleChange}
    value={formData.ipd_patient_mobile}
    required
    minLength="10"
    maxLength="10"
    pattern="\d{10}"
    title="Please enter a valid 10-digit mobile number"
  />
</div>

                                                </div>
                                                 <div class="col-md-12">
                                                    <br />
                                                </div>
                                               
                                                <div class="col-md-4">
                                                    <div>
                                                        <label for="productname-field" class="form-label">Guardian</label>
                                                        <div class="row">
                                                            <div class="col-md-4">
                                                                <select class="form-control" data-trigger="" name="ipd_guardien_title" 
                                                                onChange={handleChange} value={formData.ipd_guardien_title}>
                                                                    <option value="C/O">C/O</option>
                                                                    <option value="S/O">S/O</option>
                                                                    <option value="D/O">D/O</option>
                                                                </select>
                                                            </div>
                                                            <div class="col-md-8">
                                                                <input type="text" class="form-control" placeholder="Enter Name" name="ipd_guardien_name" 
                                                                onChange={handleChange} value={formData.ipd_guardien_name} required/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* ===== Age with Year / Month / Day fields ===== */}
<div className="col-md-4">
  <div className="mb-3">
    <label htmlFor="ipd_age" className="form-label">Age</label>

    {/* big visible field (keeps old ipd_age text if you want) */}
    <input
      id="ipd_age"
      type="text"
      className="form-control"
      placeholder="Age (e.g. 2 Years 3 Months)"
      name="ipd_age"
      onChange={handleChange}
      value={formData.ipd_age || ''}
      readOnly // keep readOnly so users edit via Y/M/D fields below
    />

    {/* small Y/M/D fields under the main field */}
    <div className="d-flex mt-2" style={{ gap: "6px" }}>
      <div style={{ flex: "1 0 33%" }}>
        <input
          type="number"
          className="form-control form-control-sm"
          name="ipd_age_year"
          placeholder="Year"
          min="0"
          onChange={handleChange}
          value={formData.ipd_age_year ?? ''}
        />
      </div>
      <div style={{ flex: "1 0 33%" }}>
        <input
          type="number"
          className="form-control form-control-sm"
          name="ipd_age_month"
          placeholder="Month"
          min="0"
          max="11"
          onChange={handleChange}
          value={formData.ipd_age_month ?? ''}
        />
      </div>
      <div style={{ flex: "1 0 33%" }}>
        <input
          type="number"
          className="form-control form-control-sm"
          name="ipd_age_day"
          placeholder="Day"
          min="0"
          max="31"
          onChange={handleChange}
          value={formData.ipd_age_day ?? ''}
        />
      </div>
    </div>
    <small className="form-text text-muted">Enter Year / Month / Day.</small>
  </div>
</div>

                                                <div class="col-md-4">
                                                    <div class="mb-3">
                                                        <label for="firstNameinput" class="form-label">Address</label>
                                                        <input type="text" class="form-control" placeholder="Enter Address" 
                                                        name="ipd_address" onChange={handleChange} value={formData.ipd_address} />
                                                    </div>
                                                </div>
                                               
                                                <div class="col-md-4">
                                                    <div class="mb-3">
                                                        <label for="firstNameinput" class="form-label">City</label>
                                                        <input type="text" class="form-control" placeholder="Enter City" 
                                                        name="ipd_city" onChange={handleChange} value={formData.ipd_city} />
                                                    </div>
                                                </div>
                                                
                                            {/* ======================= Speciality Input ======================= */}
                                            <div className="col-md-4" ref={specRef}>
  <label className="form-label">Speciality</label>
  <Select
    options={specialityOptions}
    value={specialityOptions.find(o => String(o.value) === String(formData.ipd_specality)) || null}
    onChange={onSelectSpeciality}
    isClearable
    placeholder="Select speciality..."
  />
</div>

{/* ======================= Doctor Input ======================= */}
<div className="col-md-4" ref={docRef}>
  <label className="form-label">Referred Doctor</label>
  <Select
    options={doctorOptions}
    value={doctorOptions.find(o => String(o.value) === String(formData.ipd_refer_doctor)) || null}
    onChange={onSelectDoctor}
    isClearable
    placeholder="Select doctor..."
    noOptionsMessage={() => formData.ipd_specality ? "No doctors for selected speciality" : "Select speciality to filter"}
  />
</div>
{/* Add this after the Referred Doctor field */}
<div className="col-md-6">
  <div className="d-flex align-items-center justify-content-between mb-1">
    <label className="form-label mb-0">Referral Broker(s)</label>
    <button
      type="button"
      className="btn btn-success btn-sm"
      onClick={() => setShowBrokerModal(true)}
    >
      <i className="ri-add-line me-1"/>Add Referral
    </button>
  </div>
  <Select
    isMulti
    isClearable
    placeholder="Type name or phone number..."
    options={brokerOptions}
    isLoading={loadingBrokers}
    onInputChange={(val, action) => {
      if (action.action === 'input-change') {
        if (brokerDebounceRef.current) clearTimeout(brokerDebounceRef.current);
        brokerDebounceRef.current = setTimeout(() => loadBrokers(val), 300);
      }
    }}
    onChange={(opts) => {
      setSelectedBrokers(opts || []);
    }}
    value={selectedBrokers}
    // Custom filter: match name OR phone
    filterOption={(option, inputValue) => {
      if (!inputValue) return true;
      const search = inputValue.toLowerCase();
      const label = (option.label || '').toLowerCase();
      const phone = (option.data?.phone || '').toLowerCase();
      const name = (option.data?.name || '').toLowerCase();
      return label.includes(search) || phone.includes(search) || name.includes(search);
    }}
    menuPortalTarget={document.body}
    styles={{
      menuPortal: base => ({ ...base, zIndex: 9999 }),
      multiValue: base => ({ ...base, backgroundColor: '#e8f0fe', borderRadius: '4px' }),
      multiValueLabel: base => ({ ...base, color: '#1a73e8', fontWeight: 500 }),
    }}
    noOptionsMessage={() => loadingBrokers ? 'Loading...' : 'No brokers found'}
    formatOptionLabel={(opt, { context }) => {
      // In dropdown: show name + phone separately styled
      // In selected value (tags): show just name
      if (context === 'value') {
        return <span>{opt.name || opt.label}</span>;
      }
      return (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontWeight: 500 }}>{opt.name || opt.label}</span>
          {opt.phone && (
            <span style={{ fontSize: 12, color: '#666', marginLeft: 8 }}>
              📱 {opt.phone}
            </span>
          )}
        </div>
      );
    }}
  />
  {selectedBrokers.length > 1 && (
    <small className="text-muted">
      Commission will be distributed among {selectedBrokers.length} brokers
    </small>
  )}
</div>



<div class="col-md-6">
  <div class="mb-3">
    <label for="ipdFileNumber" class="form-label">IPD File Number</label>
    <input
      id="ipdFileNumber"
      type="text"
      class="form-control"
      placeholder="Auto generated IPD file number"
      name="ipd_file_number"
      value={formData.ipd_file_number || ''}
      readOnly
    />
  </div>
</div>

                                                {/* <div class="col-md-4">
                                                    <div class="mb-3">
                                                        <label for="firstNameinput" class="form-label">Attachment</label>
                                                        <input type="file" class="form-control" 
                                                        name="ipd_attachment" onChange={handleChange} value={formData.ipd_attachment} />
                                                    </div>
                                                </div> */}
                                                
                                                {/* Insurance select */}
<div className="col-md-6">
  <div className="mb-3">
    <label className="form-label">Insurance Company</label>
    <Select
      options={insuranceOptions}
      value={selectedInsurance}
      onChange={handleInsuranceChange}
      isClearable
      placeholder="Select insurance..."
    />
  </div>
</div>

{/* TPA select */}
<div className="col-md-6">
  <div className="mb-3">
    <label className="form-label">TPA </label>
    <Select
      options={tpaOptions}
      value={selectedTpa}
      onChange={handleTpaChange}
      isClearable
      placeholder="Select TPA..."
      isDisabled={tpaOptions.length === 0}
      noOptionsMessage={() => selectedInsurance ? "No TPA for selected insurance" : "Select insurance first"}
    />
  </div>
</div>

{/* keep a read-only Insurance address field (optional) */}
<div className="col-md-6">
  <div className="mb-3">
    <label className="form-label">Insurance Address</label>
    <input type="text" className="form-control" name="ipd_policy_address"
      value={formData.ipd_policy_address || ''} readOnly />
  </div>
</div>


<div className="col-md-6">
  <div className="mb-3">
    <label className="form-label">Registration Date & Time</label>
    <input
      type="datetime-local"
      className="form-control"
      name="ipd_reg_date"
      value={toDateTimeLocal(formData.ipd_reg_date)}
      onChange={handleChange}
      readOnly={!isAdmin}
      style={!isAdmin ? { background: "#eee" } : {}}
    />
  </div>
</div>

                                                <div class="col-lg-12">
                                                    <br /> <br />
                                                    
                                                    <h5 style={{ color: "#405189" }}>IPD Case</h5>
                                                    <br />
                                                </div>
                                                <div className="col-md-4">
  <label className="form-label">Case</label>
  <Select
    options={caseOptions}
    value={caseOptions.find(o => String(o.value) === String(formData.ipd_case)) || null}
    onChange={onSelectCase}
    isClearable
    placeholder="Select case..."
  />
</div>

                                                <div class="col-md-4">
                                                    <div class="mb-3">
                                                        <label for="firstNameinput" class="form-label">MLC Number</label>
                                                        <input type="text" class="form-control" placeholder="Enter MLC Number" 
                                                        name="ipd_mlc_number" onChange={handleChange} value={formData.ipd_mlc_number} />
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="mb-3">
                                                        <label for="firstNameinput" class="form-label">Contact Number</label>
                                                        <input type="text" class="form-control" placeholder="Enter Contact Number" 
                                                        name="ipd_cont_number" onChange={handleChange} value={formData.ipd_cont_number} />
                                                    </div>
                                                </div>
                                                <div class="col-lg-12">
                                                    <br /> <br />
                                                    <h5 style={{ color: "#405189" }}>Bed Details</h5>
                                                    <br />
                                                </div>
                                                <div className="col-md-4">
  <label className="form-label">Select Ward</label>
  <Select
    options={wardOptions}
    value={wardOptions.find(o => String(o.value) === String(formData.ipd_ward)) || null}
    onChange={onSelectWard}
    isClearable
    placeholder="Select ward..."
  />
</div>

<div className="col-md-4">
  <label className="form-label">Select Bed</label>
  <Select
    options={bedOptions}
    value={bedOptions.find(o => String(o.value) === String(formData.ipd_bed)) || null}
    onChange={onSelectBed}
    isClearable
    isDisabled={!formData.ipd_ward}
    placeholder={formData.ipd_ward ? "Select bed..." : "Select ward first"}
  />
</div>

                                                <div class="col-md-4">
                                                    <div class="mb-3">
                                                        <label for="firstNameinput" class="form-label">Bed Price</label>
                                                        <input type="text" class="form-control" name="ipd_bed_price"
            value={formData.ipd_bed_price} onChange={handleChange} readOnly />
                                                    </div>
                                                </div>
                                                                         <div class="col-lg-12">
                                                    <br /> <br />
                                                    <h5 style={{ color: "#405189" }}>Package Details</h5>
                                                    <br />
                                                </div>
                                                <div className="col-md-4">
  <label className="form-label">Package</label>
  <Select
    options={packageOptions}
    value={packageOptions.find(o => String(o.value) === String(formData.ipd_pkg)) || null}
    onChange={onSelectPackage}
    isClearable
    placeholder="Select package..."
  />
</div>

<div className="col-md-4">
  <div className="mb-3">
    <label className="form-label">Package Price</label>
    <input 
      type="text" 
      className="form-control" 
      name="ipd_pkg_price"
      value={formData.ipd_pkg_price || ''}
      onChange={handleChange} 
       
    />
  </div>
</div>

<div className="col-md-4">
  <div className="mb-3">
    <label className="form-label">Package Discount</label>
    <input 
      type="number" 
      className="form-control" 
      placeholder="Enter Discount"
      name="ipd_pkg_discount" 
      onChange={handleChange} 
      value={formData.ipd_pkg_discount} 
      disabled={formData.ipd_pkg_price === 0}
    />
  </div>
</div>

                                              {/* Payment section container (ensure this is inside a .row parent if used elsewhere) */}
<div className="row">
  <div className="col-lg-12">
    <br /> <br />
    <h5 style={{ color: "#405189" }}>Payment Details</h5>
    <br />
  </div>

  {/* Row 1 */}
  <div className="col-md-4">
    <div className="mb-3">
      <label htmlFor="ipdTotalPrice" className="form-label">Total Price</label>
      <input
        id="ipdTotalPrice"
        type="text"
        className="form-control"
        name="ipd_total_price"
        value={formData.ipd_total_price || ''}
       
      />
    </div>
  </div>

  <div className="col-md-4">
    <div className="mb-3">
      <label htmlFor="ipdDiscount" className="form-label">Discount Amount</label>
      <input
  id="ipdDiscount"
  type="number"
  className="form-control"
  placeholder="Enter Discount Amount"
  name="ipd_discount"
  onChange={handleChange}
  value={formData.ipd_discount ?? ''}
  onFocus={(e) => attachWheelPrevent(e.target)}
  onBlur={(e) => detachWheelPrevent(e.target)}
/>
    </div>
  </div>

  <div className="col-md-4">
    <div className="mb-3">
      <label htmlFor="ipdRegCharges" className="form-label">Registration Charges</label>
      <input
        id="ipdRegCharges"
        type="text"
        className="form-control"
        placeholder="Registration Charges"
        name="ipd_reg_charges"
        onChange={handleChange}
        value={formData.ipd_reg_charges ?? ''}
        readOnly
      />
    </div>
  </div>

  {/* Row 2 */}
  <div className="col-md-4">
    <div className="mb-3">
      <label htmlFor="ipdPaid" className="form-label">Paid Amount (Now)</label>
      <input
  id="ipdPaid"
  type="number"
  className="form-control"
  placeholder="Enter Paid Amount"
  name="ipd_paid"
  onChange={handleChange}
  value={formData.ipd_paid}
  onFocus={(e) => {
    // existing logic
    if (String(formData.ipd_paid) === "0" || String(formData.ipd_paid) === "0.00") {
      setFormData(prev => ({ ...prev, ipd_paid: "" }));
    }
    // attach wheel prevention
    attachWheelPrevent(e.target);
  }}
  onBlur={(e) => {
    if (e.target.value === "" || e.target.value === null) {
      setFormData(prev => ({ ...prev, ipd_paid: "0" }));
    }
    // detach wheel prevention
    detachWheelPrevent(e.target);
  }}
/>
     
    </div>
  </div>

  

  <div className="col-md-4">
    <div className="mb-3">
      <label htmlFor="ipdDue" className="form-label">Due</label>
      <input
        id="ipdDue"
        type="text"
        name="ipd_due"
        className="form-control"
        value={formData.ipd_due ?? '0.00'}
        readOnly
      />
    </div>
  </div>

  {/* Row 3 */}
  <div className="col-md-4">
    <div className="mb-3">
      <label htmlFor="ipdPayMode" className="form-label">Payment Mode</label>
      <select
        id="ipdPayMode"
        className="form-control"
        name="ipd_pay_mode"
        onChange={handleChange}
        value={formData.ipd_pay_mode ?? 'cash'}
      >
      
        <option value="cash">Cash</option>
        <option value="online">Online</option>
        <option value="card">Card</option>
      </select>
    </div>
  </div>

  <div className="col-md-12">
    <div className="mb-3">
      <label htmlFor="ipdRemarks" className="form-label">Remarks</label>
      <textarea
        className="form-control"
        id="ipdRemarks"
        placeholder="Enter Remarks"
        name="ipd_remarks"
        onChange={handleChange}
        value={formData.ipd_remarks ?? ''}
        rows={3}
      />
    </div>
  </div>
</div>


                                                <div class="col-lg-12">
                                                    <br /><br />
                                                    <div class="text-end">
                                                        <button type="submit" class="btn btn-primary">Save</button>
                                                        &nbsp;&nbsp;&nbsp;
                                                        <button
  type="button"
  className="btn btn-info"
  disabled={!(isSaved && formData.ipd_uhid)}
  onClick={() => printThermalBarcodeIframe(
    formData.ipd_patient_name || formData.ipd_patient_title,
    formData.ipd_age || '',
    formData.ipd_uhid
  )}
>
  Print Barcode
</button>



                                                        &nbsp;&nbsp;&nbsp;
                                                        <button type="button" class="btn btn-dark" disabled={!isSaved}  onClick={handlePrint}>Print Admission Form</button>
                                                        &nbsp;&nbsp;&nbsp;



                                                        &nbsp;&nbsp;&nbsp;
<button
  type="button"
  className="btn btn-dark"
  disabled={!isSaved}
  onClick={() => generateInvestigationPdf(admissionData)}
>
  Print Investigation Form
</button>  &nbsp;&nbsp;&nbsp;
                                                        <button
  type="button"
  className="btn btn-dark"
  disabled={!isSaved}
  onClick={() => generateChecklistPdf(admissionData)}
>
  Print Checklist Form
</button>
&nbsp;&nbsp;&nbsp;
<button
  type="button"
  className="btn btn-dark"
  disabled={!isSaved}
  onClick={() => generateVisitingPdf(admissionData)}
>
  Print Visiting Form
</button>

                                                         &nbsp;&nbsp;&nbsp;
                                                         <button
    type="button"
    className="btn btn-danger"
    onClick={() => navigate("/ipd_pataint_list")}
    
  >
    Close
  </button>
                                                    </div>
                                                </div>
                                            </div>


{/* ── IPD PATIENT SELECTION MODAL ── */}
{showIpdPatientModal && (
    <div className="modal fade show d-block" tabIndex="-1"
        style={{backgroundColor:'rgba(0,0,0,0.5)', zIndex:10000}}>
        <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
                <div className="modal-header bg-primary text-white">
                    <h5 className="modal-title">
                        <i className="ri-group-line me-2"/>
                        Select Patient — {ipdPatientResults.length} found
                    </h5>
                    <button type="button" className="btn-close btn-close-white"
                        onClick={() => setShowIpdPatientModal(false)}/>
                </div>
                <div className="modal-body p-2">
                    {ipdPatientResults.map((p, idx) => {
                        const age = [
                            p.lab_reg_age_year  ? `${p.lab_reg_age_year}Y`  : '',
                            p.lab_reg_age_month ? `${p.lab_reg_age_month}M` : '',
                        ].filter(Boolean).join(' ') || 'N/A';
                        const labV    = p.lab_visit_count    ?? 0;
                        const ipdV    = p.ipd_visit_count    ?? 0;
                        const opdV    = p.opd_visit_count    ?? 0;
                        const pharmaV = p.pharma_visit_count ?? 0;
                        return (
                            <div key={idx} className="p-3 mb-2 rounded"
                                style={{border:'1px solid #dee2e6', cursor:'pointer',
                                    transition:'background .15s', background:'#fff'}}
                                onMouseEnter={e => e.currentTarget.style.background='#f0f4ff'}
                                onMouseLeave={e => e.currentTarget.style.background='#fff'}>
                                <div className="d-flex justify-content-between align-items-start">
                                    <div style={{flex:1}}>
                                        <div className="fw-bold fs-6">
                                            {p.lab_reg_name_title} {p.lab_reg_name}
                                        </div>
                                        <div className="text-muted mt-1" style={{fontSize:12}}>
                                            <span className="me-3">
                                                <i className="ri-fingerprint-line me-1"/>
                                                UHID: <strong>{p.lab_reg_uhid}</strong>
                                            </span>
                                            <span className="me-3">
                                                {age} / {p.lab_reg_gender}
                                            </span>
                                            <span>
                                                <i className="ri-phone-line me-1"/>
                                                {p.lab_reg_mobile}
                                            </span>
                                        </div>
                                        <div className="mt-2 d-flex gap-2 flex-wrap">
                                            {labV > 0 && (
                                                <span className="badge"
                                                    style={{background:'#cff4fc',color:'#055160',
                                                        fontSize:11,padding:'4px 8px'}}>
                                                    🧪 Lab: {labV}x
                                                </span>
                                            )}
                                            {ipdV > 0 && (
                                                <span className="badge"
                                                    style={{background:'#cfe2ff',color:'#084298',
                                                        fontSize:11,padding:'4px 8px'}}>
                                                    🏥 IPD: {ipdV}x
                                                </span>
                                            )}
                                            {opdV > 0 && (
                                                <span className="badge"
                                                    style={{background:'#d1e7dd',color:'#0f5132',
                                                        fontSize:11,padding:'4px 8px'}}>
                                                    🩺 OPD: {opdV}x
                                                </span>
                                            )}
                                            {pharmaV > 0 && (
                                                <span className="badge"
                                                    style={{background:'#fff3cd',color:'#664d03',
                                                        fontSize:11,padding:'4px 8px'}}>
                                                    💊 Pharma: {pharmaV}x
                                                </span>
                                            )}
                                            {(labV+ipdV+opdV+pharmaV) === 0 && (
                                                <span className="badge bg-secondary"
                                                    style={{fontSize:11}}>New Patient</span>
                                            )}
                                        </div>
                                    </div>
                                    <button type="button"
                                        className="btn btn-sm btn-primary ms-3"
                                        onClick={() => applyIpdPatient(p)}>
                                        <i className="ri-check-line me-1"/>Select
                                    </button>
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary"
                        onClick={() => setShowIpdPatientModal(false)}>Cancel</button>
                </div>
            </div>
        </div>
    </div>
)}
                                        </form>
                                    </div>

                                </div>
                            </div>
                     
                    </div>
                </div>
            </div>


            <NewBroker
  item={null}
  show={showBrokerModal}
  onClose={(refresh) => {
    setShowBrokerModal(false);
    if (refresh) {
      loadBrokers('');
    }
  }}
/>
        </div>
    );
}

export default OpdRegistrations;
